<template>
  <div id="reservation-user-info" :class="isPhone ? 'reservation-user-info-phone' : ''" v-if="userInfo">
    <Modalsignup v-if="showModal" :showModalLogin="showModalLogin" @close="setUser"></Modalsignup>
    <!-- <div class="banner-resa"> -->
    <!-- todo
    </div> -->

    <div class="container-reservation pb-5">
      <div class="row row-reservation">
        <div class="col-12 col-md-7 order-2 order-md-1 col-info-left">
          <div class="d-flex flex-column justify-content-center align-items-start selection-main-div">
            <div class="d-flex justify-content-start align-items-start mb-4" v-if="!isPhone" @click="close()">
              <div class="back-button d-flex align-items-center justify-content-center">
                <img class="ml-2" src="../../images/arrow-left-small.svg" alt="Back" style="width: 15px; height: 17.5px;" />
              </div>
            </div>
            <div class="discount-container w-100">
              <DiscountBanner
                :isLoggedIn="!!user"
                :isCodeUsed="loyaltyUser && loyaltyUser.is_code_used"
                :userName="user ? `${user.first_name}` : ''"
                :privilegesText="this.privilegesText(false)"
                @showLoginModal="showModal = true; showModalLogin = true;"
                @showSignupModal="showModalLogin = false;showModal = true"
              />
            </div>
          </div>

          <div v-if="!isPhone" class="border-bottom pb-4"></div>
          <div class="steps-container" id="steps-container-main">
            <div v-if="step !== 4" class="form-steps" :class="isPhone ? 'mx-4' : ''">
              <div class="step-item">
                <div :class="['step-circle', step >= 1 ? 'active' : '', step >= 1 && (informationsCompleted || user) ? 'completed' : '']">
                  <img v-if="step >= 1 && (informationsCompleted || user)" src="../../images/tick_white.svg" alt="completed" class="step-tick" />
                  <span v-else>1</span>
                </div>
                <span class="step-label">RENSEIGNER</br> vos informations</span>
              </div>

              <div class="step-bar mb-5" :class="{ completed: step > 2 }"></div>

              <div v-if="hasSupplementsStep" class="step-item">
                <div :class="['step-circle', step === 2 ? 'active' : '', step >= 3 ? 'completed' : '']">
                  <img v-if="step >= 3" src="../../images/tick_white.svg" alt="completed" class="step-tick" />
                  <span v-else>2</span>
                </div>
                <span class="step-label">PERSONNALISER</br> votre séjour</span>
              </div>

              <div v-if="hasSupplementsStep" class="step-bar mb-5" :class="{ completed: step > 2 }"></div>

              <div class="step-item align-items-end">
                <div :class="['step-circle', step === 3 ? 'active' : '', step > 3 ? 'completed' : '']">
                  <img v-if="step > 3" src="../../images/tick_white.svg" alt="completed" class="step-tick" />
                  <span v-else>{{ hasSupplementsStep ? 3 : 2 }}</span>
                </div>
                <span class="step-label" :style="isPhone ? 'margin-right: -24px;' : 'margin-right: -30px'">FINALISER</br> votre réservation</span>
              </div>
            </div>
          </div>
          <div class="details-container" :class="isPhone ? '' : 'pt-5'">
            <div class="row row-one-info">
              <div ref="informationSection" class="col-lg-12 col-info-form">
                <div class="step-block" v-if="informationsCompleted && !this.user">
                  <div class="step-banner-header">
                    <div class="step-banner-number">1</div>
                    <span class="step-banner-title">Renseigner vos informations</span>
                  </div>
                  <div class="step-block-content">
                    <div class="">
                      <p class="raleway-reg-p15 mb-0">
                        {{ userInfo.last_name }}, {{ userInfo.first_name }}
                      </p>
                      <p class="raleway-reg-p15 mb-0" v-if="userInfo.country && userInfo.city">{{ userInfo.country }}, {{ userInfo.city }}</p>
                      <p class="raleway-reg-p15 mb-0">{{ userInfo.email }}</p>
                      <p class="raleway-reg-p15">{{ userInfo.phone }}</p>
                    </div>
                    <a class="____link raleway-reg-p15 cursor-pointer mb-2" @click="informationsCompleted = false" v-if="!this.user">Modifier</a>
                    <ReservationPointsBanner
                      :reservationPoints="reservationPoints"
                      :loyaltyUser="loyaltyUser"
                      :greenTrotters="lodging.green_trotters || []"
                      :statusArrowStyle="statusArrowStyle"
                      :eventLodging="eventLodging"
                      class="mt-3 mb-2"
                    />
                    <div v-if="!hasSupplementsStep" class="d-flex flex-column">
                      <p class="text-center ____link raleway-semi-p15 cursor-pointer text-green" @click="showSpecialRequests = !showSpecialRequests">
                        J'ai des demandes spéciales
                      </p>
                      <div v-if="showSpecialRequests" class="pt-3">
                        <p class="raleway-reg-p13">Les demandes spéciales (par exemple : lit bébé, lit d'appoint, diner, panier repas...) sont soumises à disponibilité et doivent être confirmées par l'établissement. Elles ne peuvent pas être garanties et peuvent, dans certains cas, entraîner des frais supplémentaires (sauf mention « gratuit »). L'établissement fera toutefois tout son possible pour y répondre.</p>
                        <textarea
                          v-model="specialRequests"
                          class="special-requests-textarea"
                          placeholder="Veuillez nous informer de toute demande additionnelle pour nous aider à personnaliser votre séjour"
                          rows="4"
                        ></textarea>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center w-100" :class="isPhone ? '' : 'pt-3'" >
                      <button class="hortense-btn-primary d-flex" @click="changeStep(1)">
                        ÉTAPE SUIVANTE
                      </button>
                    </div>
                  </div>
                </div>
                <div class="step-block" v-if="this.user">
                  <div class="step-banner-header">
                    <div class="step-banner-number">1</div>
                    <span class="step-banner-title">Renseigner vos informations</span>
                  </div>
                  <div class="step-block-content">
                    <div class="">
                      <p class="raleway-reg-p15 mb-0">
                        {{ userInfo.last_name }}, {{ userInfo.first_name }}
                      </p>
                      <p class="raleway-reg-p15 mb-0" v-if="userInfo.country && userInfo.city">{{ userInfo.country }}, {{ userInfo.city }}</p>
                      <p class="raleway-reg-p15 mb-0">{{ userInfo.email }}</p>
                      <p class="raleway-reg-p15">{{ userInfo.phone }}</p>
                    </div>
                    <div :class="isPhone ? '' : 'pt-2'">
                      <!-- Phone number field for logged-in users without phone -->
                      <div v-if="user && phoneNotRegistered" class="phone-input-section mb-4">
                        <p class="raleway-reg-p13 mb-3" style="color: #D56A70;">
                          Votre numéro de téléphone est nécessaire afin que l'établissement puisse vous contacter en cas de besoin concernant votre réservation (heure d'arrivée, informations pratiques…).
                        </p>
                        <label for="phone-input" class="col-12 col-md-6 px-0">
                          Téléphone*
                          <input
                            id="phone-input"
                            v-model="userInfo.phone"
                            type="text"
                            placeholder="Entrez votre numéro de téléphone"
                          />
                        </label>
                      </div>

                      <ReservationPointsBanner
                        :reservationPoints="reservationPoints"
                        :loyaltyUser="loyaltyUser"
                        :greenTrotters="lodging.green_trotters || []"
                        :statusArrowStyle="statusArrowStyle"
                        :eventLodging="eventLodging"
                        class="mt-3 mb-2"
                      />
                      <div v-if="!hasSupplementsStep" class="d-flex flex-column">
                        <p class="text-center ____link raleway-semi-p15 cursor-pointer text-green" @click="showSpecialRequests = !showSpecialRequests">
                          J'ai des demandes spéciales
                        </p>
                        <div v-if="showSpecialRequests" class="pt-3">
                          <p class="raleway-reg-p13">Les demandes spéciales (par exemple : lit bébé, lit d'appoint, diner, panier repas...) sont soumises à disponibilité et doivent être confirmées par l'établissement. Elles ne peuvent pas être garanties et peuvent, dans certains cas, entraîner des frais supplémentaires (sauf mention « gratuit »). L'établissement fera toutefois tout son possible pour y répondre.</p>
                          <textarea
                            v-model="specialRequests"
                            class="special-requests-textarea"
                            placeholder="Veuillez nous informer de toute demande additionnelle pour nous aider à personnaliser votre séjour"
                            rows="4"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center w-100" :class="isPhone ? '' : 'pt-3'" >
                      <button class="hortense-btn-primary d-flex" @click="changeStep(1)">
                        ÉTAPE SUIVANTE
                      </button>
                    </div>
                    <p v-if="missingPhoneForLoggedUser" class="raleway-medi-p12 text-center pt-4" style="color: #D56A70;">Veuillez saisir votre numéro de téléphone pour passer à l'étape suivante. Il permet à l'établissement de vous accueillir dans les meilleures conditions.</p>
                  </div>
                </div>

                <div class="step-block" v-if="!informationsCompleted && !this.user">
                  <div class="step-banner-header">
                    <div class="step-banner-number">1</div>
                    <span class="step-banner-title">Renseigner vos informations</span>
                  </div>
                  <div class="step-block-content">
                  <div class="row mt-4">
                    <div v-if="!this.user" class="col-12 order-1" :class="isPhone ? '' : 'mb-2'">
                      <div v-if="!this.user" class="row">
                        <p class="raleway-reg-p15 col-md-6 col-12" :class="isPhone ? '' : 'text-center'">
                          Vous avez déjà un compte client ?<br>
                          Veuillez <span class="link-hortense raleway-semi-p15" @click="connectModal">vous connecter.</span>.
                        </p>
                        <p class="raleway-reg-p15 col-md-6 col-12" :class="isPhone ? '' : 'text-center'">
                          Si cela n’est pas le cas, vous pouvez<br>
                          <span class="link-hortense raleway-semi-p15" @click="signupModal">créer un compte ici.</span>.
                        </p>
                      </div>
                      <p class="raleway-medi-p12 text-red" :class="isPhone ? '' : 'text-center'">
                        La création d'un compte n'est pas obligatoire pour FINALISER LA RÉSERVATION. Toutefois, celle-ci est nécessaire pour bénéficier des privilèges du Club Hortense
                      </p>
                    </div>
                    <div class="col-12 order-md-1 order-2">
                      <div class="line-form row" :class="isPhone ? '' : ' mb-4'">
                        <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'"
                        >Nom*
                          <input v-model="userInfo.last_name" type="text" />
                        </label>
                        <label for="name" class="col-12 col-md-6"
                        >Prénom*
                          <input v-model="userInfo.first_name" type="text" />
                        </label>
                      </div>
                      <div class="line-form row mb-3">
                        <label for="name" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'"
                        >Email*
                          <input v-model="userInfo.email" type="text" />
                        </label>
                        <label for="name" class="col-12 col-md-6"
                        >Téléphone*
                          <input v-model="userInfo.phone" type="text" />
                        </label>
                      </div>
                      <p class="raleway-semi-italic-p10">* informations obligatoires</p>
                      <p class="raleway-medi-p12 text-red py-4" v-if="isPhone">
                        Si vous disposez déjà d'un compte client, veillez à être connecté à votre espace client avant de valider la réservation.
                      </p>
                    </div>
                  </div>
                  <ReservationPointsBanner
                    :reservationPoints="reservationPoints"
                    :loyaltyUser="loyaltyUser"
                    :greenTrotters="lodging.green_trotters || []"
                    :statusArrowStyle="statusArrowStyle"
                    :eventLodging="eventLodging"
                    class="mt-3 mb-2"
                  />
                  <div v-if="!hasSupplementsStep" class="d-flex flex-column">
                    <p class="text-center ____link raleway-semi-p15 cursor-pointer text-green" @click="showSpecialRequests = !showSpecialRequests">
                      J'ai des demandes spéciales
                    </p>
                    <div v-if="showSpecialRequests" class="pt-3">
                      <p class="raleway-reg-p13">Les demandes spéciales (par exemple : lit bébé, lit d'appoint, diner, panier repas...) sont soumises à disponibilité et doivent être confirmées par l'établissement. Elles ne peuvent pas être garanties et peuvent, dans certains cas, entraîner des frais supplémentaires (sauf mention « gratuit »). L'établissement fera toutefois tout son possible pour y répondre.</p>
                      <textarea
                        v-model="specialRequests"
                        class="special-requests-textarea"
                        placeholder="Veuillez nous informer de toute demande additionnelle pour nous aider à personnaliser votre séjour"
                        rows="4"
                      ></textarea>
                    </div>

                  </div>
                  <div class="d-flex justify-content-center w-100" :class="isPhone ? '' : 'pt-3'" >
                    <button class="hortense-btn-primary d-flex" @click="changeStep(1)">
                      ÉTAPE SUIVANTE
                    </button>
                  </div>
                  <p v-if="incompleteInformation" class="raleway-medi-p12 text-center pt-4" style="color: #D56A70;">Vous devez renseigner les informations obligatoires pour passer à l'étape suivante.</p>
                  </div>
                </div>
                <div v-if="hasSupplementsStep" class="step-block" id="step-supplements">
                  <div class="step-banner-header">
                    <div class="step-banner-number">2</div>
                    <span class="step-banner-title">Personnaliser votre séjour</span>
                  </div>
                  <div class="step-block-content">
                    <p class="raleway-reg-p13 mb-0" :class="isPhone ? 'text-center' : ''" style="color: #707070;">Cliquez sur un service pour l'ajouter à votre réservation.</p>
                    <div class="mt-4">
                      <SupplementsSelector
                        v-model="selectedSupplementsMap"
                        :lodging="lodging"
                        :numberOfNights="numberOfNights"
                      />
                      <p class="text-center ____link raleway-semi-p15 cursor-pointer text-green" @click="showSpecialRequests = !showSpecialRequests">
                        J'ai des demandes spéciales
                      </p>
                      <div v-if="showSpecialRequests" class="pt-3">
                        <p class="raleway-reg-p13">Les demandes spéciales (par exemple : lit bébé, lit d'appoint, diner, panier repas...) sont soumises à disponibilité et doivent être confirmées par l'établissement. Elles ne peuvent pas être garanties et peuvent, dans certains cas, entraîner des frais supplémentaires (sauf mention « gratuit »). L'établissement fera toutefois tout son possible pour y répondre.</p>
                        <textarea
                          v-model="specialRequests"
                          class="special-requests-textarea"
                          placeholder="Veuillez nous informer de toute demande additionnelle pour nous aider à personnaliser votre séjour"
                          rows="4"
                        ></textarea>
                      </div>
                      <div class="d-flex justify-content-center w-100" :class="isPhone ? '' : 'pt-3'">
                        <button class="hortense-btn-primary d-flex" @click="changeStep(2)">
                          ÉTAPE SUIVANTE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!hideTemporarySections" class="step-from-1" id="step-1">
                  <div class="">
                    <p class="raleway-semi-p15 mb-0" :class="isPhone ? 'text-center' : ''">2. Soutenir le tourisme durable</p>
                  </div>
                  <div class="tourism-section mt-4" v-if="informationsCompleted">
                    <div class="card-evergreen">
                      <div class="head d-flex flex-column flex-md-row">
                        <div class="eg-logo" aria-hidden="true">
                          <img src="../../images/logo_evergreen.svg"/>
                        </div>
                        <div class="content">
                          <p class="raleway-semi-p16 text-uppercase mb-0">Programme evergreen</p>
                          <p class="raleway-reg-p15 mb-0">
                            Hortense s’engage concrètement pour un tourisme plus durable.<br> Pour chaque réservation, 1 % du montant est reversé aux hôteliers partenaires afin de soutenir des projets durables visant à réduire l’impact environnemental de leurs établissements. Vous ne payez rien en plus, Hortense reverse simplement un pourcentage de sa commission !
                          </p>
                        </div>
                        <div style="display: none;">
                          <button class="modal-arrow" @click="showEvergreens = !showEvergreens">
                            <img class="" src="../../images/flechebas-simple.svg" v-set-alt />
                          </button>
                        </div>
                      </div>
                      <div class="cards" v-if="this.evergreens && this.showEvergreens === true">
                        <slither-slider
                            class="slither-slider"
                            :options="{
                            numberOfSlides: 2,
                            autoplay: false,
                            controls: true,
                            extras: 2,
                            loop: true,
                            dots: false,
                            touch: true,
                          }"
                        >
                          <template v-for="evergreen in this.evergreens">
                            <div id="cardEvergreen">
                              <div class="card-ever">
                                <img :src="evergreen.photo_key" v-set-alt />
                                <div class="sticker-program d-flex mt-4 pl-2">
                                  <div class="sticker-program-info d-flex">
                                    <p class="raleway-bold-h3 mb-0 pl-1 pr-2">
                                      {{ evergreen.title }}
                                    </p>
                                    <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
                                      {{ evergreen.goal }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template slot="previous">
                            <div class="previous">
                              <img src="../../images/fleche gauche.svg" v-set-alt />
                              <p class="raleway-reg-p13 m-0">PLUS</p>
                            </div>
                          </template>
                          <template slot="next">
                            <img src="../../images/fleche droite.svg" v-set-alt />
                          </template>
                        </slither-slider>
                      </div>
                    </div>
                    <div class="pt-4 pb-3">
                      <span class="____link raleway-reg-p15 cursor-pointer" @click="showCarbonOffsetSection = !showCarbonOffsetSection">Je compense les émissions de mon séjour</span>
                    </div>
                    <div class="card-carbon-offset">
                      <div class="head" v-if="showCarbonOffsetSection">
                        <p class="raleway-semi-p16 text-uppercase">Emission de CO² pour votre voyage</p>
                      </div>
                      <div class="row row-transport" v-if="showCarbonOffsetSection">
                        <p class="raleway-reg-p15">Vous pouvez aussi, de manière facultative, compenser l’empreinte carbone de votre séjour selon votre mode de transport.</p>
                        <div class="col-12 col-md-12 row-transport-item border-bottom-gray pb-2">
                          <div class="d-flex align-items-center" style="gap: 10px;">
                            <img src="../../images/icon_moon.svg" v-set-alt />
                            <div class="raleway-reg-p15">Nuits d’hôtel</div>
                            <div class="raleway-semi-p12 align-center green-color">
                              {{ compensationByNightsAndTravelers.compensation_carbon_offset.toFixed(2) }}
                              Kg de CO²<br />
                            </div>
                          </div>
                          <p class="raleway-semi-p15 mt-2 green-color">{{ compensationByNightsAndTravelers.compensation_amount.toFixed(2) }}€/nuit</p>
                        </div>
                        <div v-if="this.distanceBetween !== undefined" class="col-12 col-md-12 row-transport-item" :class="isPhone ? '' : 'py-4  border-bottom-gray'">
                          <div class="row">
                            <div
                                class="col-12 col-md-4 cursor-pointer distance-item border-right-gray"
                                :class="{
                                green: selectedTransportEngin === 'train'
                              }"
                                @click="chooseTransportEngine('compensationByTrain', 'train')"
                            >
                              <div class="d-flex align-items-center" style="gap: 10px;">
                                <img src="../../images/train.svg" v-set-alt />
                                <div class="raleway-reg-p15">Train</div>
                                <div class="raleway-semi-p12 green-color text-nowrap">
                                  {{ compensationByTrain.compensation_carbon_offset.toFixed(2) }}
                                  Kg de CO²
                                </div>
                              </div>
                              <span class="raleway-semi-p15 mt-2 green-color">{{ compensationByTrain.compensation_amount.toFixed(2) }}€/nuit</span>
                            </div>

                            <div
                                class="col-12 col-md-4 cursor-pointer distance-item border-right-gray"
                                :class="{
                                green: selectedTransportEngin === 'plane',
                              }"
                                @click="chooseTransportEngine('compensationByPlane', 'plane')"
                            >
                              <div class="d-flex align-items-center" style="gap: 10px;">
                                <img src="../../images/avion.svg" v-set-alt />
                                <div class="raleway-reg-p15">Avion</div>
                                <div class="raleway-semi-p12 green-color text-nowrap">
                                  {{ compensationByPlane.compensation_carbon_offset.toFixed(2) }}
                                  Kg de CO²
                                </div>
                              </div>
                              <span class="raleway-semi-p15 mt-2 green-color">{{ compensationByPlane.compensation_amount.toFixed(2) }}€/nuit</span>
                            </div>

                            <div
                                class="col-12 col-md-4 cursor-pointer distance-item"
                                :class="{
                                green: selectedTransportEngin === 'car'
                              }"
                                @click="chooseTransportEngine('compensationByCar', 'car')"
                            >
                              <div class="d-flex align-items-center" style="gap: 10px;">
                                <img src="../../images/voiture.svg" v-set-alt />
                                <div class="raleway-reg-p15">Voiture</div>
                                <div class="raleway-semi-p12 green-color text-nowrap">
                                  {{ compensationByCar.compensation_carbon_offset.toFixed(2) }}
                                  Kg de CO²
                                </div>
                              </div>
                              <span class="raleway-semi-p15 mt-2 green-color">{{ compensationByCar.compensation_amount.toFixed(2) }}€/nuit</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 p-0">
                          <div class="carbon-offset-total">
                            <div class="raleway-reg-p14">=
                              <span class="raleway-semi-p15">
                                {{ totalCompensationCarbonOffset.toFixed(2) }} KG de CO2
                              </span>
                            </div>
                            
                            <div :class="isPhone ? '' : 'pl-4'">
                              <p class="raleway-semi-p15 mb-0">Total d’émission de carbonne <br v-if="isPhone"><span class="raleway-reg-p12">soit {{ totalCompensationAmount.toFixed(2) }}€ pour compenser cette émission</span></p>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 p-0">
                          <p class="raleway-reg-p15">
                            Avec le Club Hortense, chaque engagement compte. En choisissant la compensation carbone, vous soutenez des projets durables tout en cumulant des points de fidélité : 1 € = 1 point. Ces points vous permettent de débloquer de nouveaux statuts et d’accéder à des privilèges exclusifs lors de vos séjours : surclassement, petit déjeuner offert, bouteille de champagne…Soutenez des projets durables, gagnez des points et profitez d’attentions uniques. Plus vous cumulez, plus vous profitez.
                          </p>
                        </div>
                        <div class="col-12 p-0 pt-4">
                          <div class="row d-flex align-items-center">
                            <div class="col-12 col-md-5">
                              <div class="row px-3">
                                <input
                                    class="input-fid col green-color raleway-extra-bold-p15"
                                    type="number"
                                    placeholder="30€"
                                    @input="fromPriceToPoints"
                                    :value="compensationToPay"
                                />
                                <span class="ml-2 mt-1 green-color raleway-semi-p14">€</span>
                                <div class="equal col-2 green-color" :class="isPhone ? 'px-5' : 'px-3'">
                                  <p class="raleway-extra-bold-p18">=</p>
                                </div>
                                <input
                                    class="input-fid col green-color raleway-extra-bold-p15"
                                    type="number"
                                    placeholder="10 points de fidélité"
                                    @input="fromPointsToPrice"
                                    :value="compensationPointToEarn"
                                />
                                <span class="ml-2 raleway-semi-p14 mt-1 green-color">Points</span>
                              </div>
                            </div>
                            <div class="col-12 col-md-7">
                              <div class="compensation">
                                <div class="raleway-medi-p16 mr-1 mb-0">
                                  Total de vos points fidélité après compensation
                                  <span class="raleway-bold-p16 green-color mb-0">
                                    {{ compensationPointToEarn }}
                                    <span class="raleway-bold-p16 text-lowercase ml-1 mb-0">points de fidélité supplémentaires</span>
                                  </span>
                                </div>
                              </div>
                              <p class="raleway-reg-p12">
                                Points de fidélité gagnés avec votre compensation carbone
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="raleway-medi-p12 text-center text-light-gray pt-5" v-if="showCarbonOffsetSection">
                        Vous pouvez passer à l'étape suivante sans contribuer à la compensation carbone de votre séjour.
                      </p>
                      <div class="d-flex justify-content-center w-full pt-4" @click="step1Completed = true">
                        <button class="hortense-btn-primary" :class="isPhone ? 'w-100' : ''" @click="changeStep(hasTravelGuideImage ? 2 : 3)">Passez à l'étape suivante</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="hasTravelGuideImage && !hideTemporarySections" class="step-from-2" id="step-2">
                  <div class="">
                    <p class="raleway-semi-p15 mb-0" :class="isPhone ? 'text-center' : ''">3. Guide De Voyage</p>
                  </div>
                  <div class="description-main-section mt-4" v-if="step1Completed">
                    <div class="description-section d-flex flex-md-row flex-column">
                      <div class="image-section">
                        <img
                            :src="travelGuideImageUrl"
                            alt="guide img"
                            class="travel-guide-img"
                        >
                      </div>
                      <div class="travel-guide-description">
                        <div class="d-flex flex-column justify-content-md-between">
                          <p class="raleway-reg-p15">Enrichissez votre séjour avec notre quide de voyage exclusif pour seulement 15€ de plus ! 
                            Ce guide soigneusement élaboré regorge de trésors
                            cachés et d'expériences uniques qui vous permettront de vivre pleinement votre sejour. Découvrez les meilleurs restaurants locaux, lessites touristiques incontournables, les activités passionnantes, les lieux hors des sentiers battus et bien plus encore ! Hortense s'engage pour promouvoir un tourisme durable et authentique. Découvrez plus de 250lieux et expériences pour voyager 
                            de manière écoresponsable et explorer des sites uniques à proximité de votre lieu de séjour.</p>
                            <div class="travel-guide-check-section form-item raleway-reg-p13">
                              <input
                                type="checkbox"
                                id="guide-accept"
                                value="guide-accept"
                                @change="handleGuideAcceptanceChange"
                              />
                              <label for="guide-accept" class="raleway-semi-p15 mb-0 text-nowrap">
                                J’achète le guide de voyage
                              </label>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="info-cancelation mb-3 mt-5">
                      <div class="raleway-reg-p13 content">
                        <img src="../../images/info.svg" v-set-alt />
                        <p>
                          Veuillez noter que ce guide sera disponible en version papier dans votre chambre le jour de votre arrivée. Avant votre séjour, vous pouvez consulter la version en ligne de ce guide
                          <a :href="travelGuideLink" class="link-hortense" target="_blank" rel="noopener noreferrer">ici.</a>.
                        </p>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center w-100" :class="isPhone ? '' : 'pt-3'" @click="step2Completed = true">
                      <button class="hortense-btn-primary d-flex" :class="isPhone ? 'w-100' : ''" @click="changeStep(3)">
                        Accédez au paiement
                      </button>
                    </div>
                  </div>
                </div>
                <div class="step-block step-from-3" id="step-3">
                  <div class="step-banner-header">
                    <div class="step-banner-number">{{ hasSupplementsStep ? 3 : 2 }}</div>
                    <span class="step-banner-title">Finaliser votre réservation</span>
                  </div>
                  <div class="step-block-content">
                  <div class="section-payment">
                    <div class="payment-info-section" style="background-color: #CFE5DC77; padding: 24px;">
                      <div class="d-flex align-items-start mb-4">
                        <div>
                          <div class="d-flex align-items-center mb-3">
                            <img src="../../images/info.svg" v-set-alt style="margin-right: 12px; margin-top: 2px;" />
                            <p class="raleway-bold-p16 text-uppercase mb-0">INFORMATIONS SUR LE PAIEMENT</p>
                          </div>
                          <!-- With payment schedule -->
                          <p class="raleway-reg-p15 mb-0" v-if="paymentSchedule">
                            Votre carte ne sera pas débitée aujourd'hui. Le règlement s'effectue directement auprès de l'établissement, qui prendra contact avec vous.
                          </p>
                          <!-- Without payment schedule: original text -->
                          <p class="raleway-reg-p15 mb-0" v-else-if="!eventLodging">
                            Votre carte ne sera pas débitée. Nous avons besoin de vos informations de paiement pour garantir votre réservation.
                          </p>
                        </div>
                      </div>

                      <!-- Payment schedule timeline -->
                      <div v-if="paymentSchedule" class="payment-details-timeline ml-4" style="position: relative; padding-left: 20px;">
                        <!-- Today / online -->
                        <div class="timeline-item d-flex align-items-flex-start mb-4" style="position: relative;">
                          <div class="timeline-dot" style="width: 14px; height: 14px; background-color: #2C5E4B; border-radius: 50%; margin-right: 16px; flex-shrink: 0; position: absolute; left: -27px; top: 2px;"></div>
                          <div class="timeline-content">
                            <p class="raleway-semi-p15 mb-1">Aujourd'hui</p>
                            <p class="raleway-reg-p15 mb-0">
                              En ligne, vous paierez
                              <span class="raleway-semi-p15">{{ scheduleOnlineAmount }} EUR</span>
                              <span v-if="paymentSchedule.online_percentage > 0"> ({{ paymentSchedule.online_percentage }} %)</span>
                            </p>
                          </div>
                        </div>

                        <!-- Intermediate schedule items -->
                        <div v-for="(item, index) in sortedScheduleItems" :key="'sched-' + index">
                          <div class="timeline-connector"></div>
                          <div class="timeline-item d-flex align-items-flex-start mb-4" style="position: relative;">
                            <div class="timeline-dot" style="width: 14px; height: 14px; background-color: #2C5E4B; border-radius: 50%; margin-right: 16px; flex-shrink: 0; position: absolute; left: -27px; top: 2px;"></div>
                            <div class="timeline-content">
                              <p class="raleway-semi-p15 mb-1">{{ scheduleItemDate(item) }}</p>
                              <p class="raleway-reg-p15 mb-0">
                                {{
                                  item.offset_type === 'before_checkout'
                                    ? item.days_offset + ' ' + (item.days_offset === 1 ? 'jour' : 'jours') + ' avant l\'arrivée'
                                    : item.days_offset + ' ' + (item.days_offset === 1 ? 'jour' : 'jours') + ' après la réservation'
                                }},
                                vous paierez
                                <span class="raleway-semi-p15">{{ scheduleItemAmount(item) }} EUR</span>
                                ({{ item.percentage }} %)
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- On-site remainder -->
                        <div v-if="scheduleRemainderPercentage > 0">
                          <div class="timeline-connector"></div>
                          <div class="timeline-item d-flex align-items-flex-start" style="position: relative;">
                            <div class="timeline-dot" style="width: 14px; height: 14px; background-color: #2C5E4B; border-radius: 50%; margin-right: 16px; flex-shrink: 0; position: absolute; left: -27px; top: 2px;"></div>
                            <div class="timeline-content">
                              <p class="raleway-semi-p15 mb-1">Le {{ formatDateWithoutWeekday(from) }}</p>
                              <p class="raleway-reg-p15 mb-0">
                                Sur place, vous paierez
                                <span class="raleway-semi-p15">{{ scheduleRemainderAmount }} EUR</span>
                                (solde {{ scheduleRemainderPercentage }} %)
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Default timeline (no payment schedule, or event without bankTransfer) -->
                      <div v-else class="payment-details-timeline ml-4" style="position: relative; padding-left: 20px;">
                        <div class="timeline-item d-flex align-items-flex-start mb-4" style="position: relative;">
                          <div class="timeline-dot" style="width: 14px; height: 14px; background-color: #2C5E4B; border-radius: 50%; margin-right: 16px; flex-shrink: 0; position: absolute; left: -27px; top: 2px;"></div>
                          <div class="timeline-content">
                            <p class="raleway-semi-p15 mb-1">Aujourd'hui</p>
                            <p class="raleway-reg-p15 mb-0" v-if="eventLodging">En ligne, vous paierez <span class="raleway-semi-p15">{{ totalAmount.toFixed(2) }} EUR</span></p>
                            <p class="raleway-reg-p15 mb-0" v-else>En ligne, vous paierez <span class="raleway-semi-p15">0 EUR</span></p>
                          </div>
                        </div>
                        <div class="timeline-connector" v-if="!eventLodging"></div>
                        <div v-if="!eventLodging" class="timeline-item d-flex align-items-flex-start" style="position: relative;">
                          <div class="timeline-dot" style="width: 14px; height: 14px; background-color: #2C5E4B; border-radius: 50%; margin-right: 16px; flex-shrink: 0; position: absolute; left: -27px; top: 2px;"></div>
                          <div class="timeline-content">
                            <p class="raleway-semi-p15 mb-1">Le {{ formatDateWithoutWeekday(from) }}</p>
                            <p class="raleway-reg-p15 mb-0">Sur place, vous paierez <span class="raleway-semi-p15">{{ (totalAmount - totalCompensationCalculated).toFixed(2) }} EUR </span></p>
                          </div>
                        </div>
                      </div>
                      <p v-if="selectedSupplements.length > 0" class="raleway-reg-p15 mb-1 mt-3" style="margin-left: 2.7rem;">Services additionnels : <span class="raleway-semi-p15">{{ supplementsTotalDisplay }} EUR</span></p>

                      <div v-if="eventLodging" class="form-item raleway-reg-p13 mt-3">
                        <input
                          type="checkbox"
                          id="bank-transfer-requested"
                          value="bank-transfer-requested"
                          v-model="bankTransferRequested"
                        />
                        <label for="bank-transfer-requested" class="raleway-semi-p15 mb-0">
                          Je souhaite régler par virement
                        </label>
                      </div>
                      <p
                        v-if="eventLodging && bankTransferRequested"
                        class="raleway-reg-p13 mt-2 mb-1"
                        style="color: #D56A70;"
                      >
                        Votre carte ne sera pas débitée. Nous avons simplement besoin de vos coordonnées bancaires afin de garantir la réservation.<br>
                        Une personne de notre équipe reviendra vers vous prochainement pour vous communiquer les informations nécessaires au virement.
                      </p>
                      <p v-if="!eventLodging && !paymentSchedule" class="raleway-it-l12 mt-2 mb-1 pt-2 bottom-schedule-text">Si un acompte est requis, cela est indiqué dans les conditions d'annulation. L'établissement prendra alors directement contact avec vous afin de régler cet acompte.</p>
                    </div>
                    <div class="d-flex w-100 pt-5" :class="isPhone ? 'flex-column justify-content-start' : 'justify-content-between'">
                      <div class="d-flex" :class="isPhone ? 'flex-column align-items-baseline' : 'align-items-center'" style="gap: 10px;">                        
                        <p :class="isPhone ? 'raleway-semi-p13' : 'raleway-semi-p15'"class="mb-0 d-flex align-items-center w-full justify-content-start text-uppercase">Moyens de paiement</p>
                        <span class="raleway-medi-p14 text-green" :class="isPhone ? '' : 'ml-1'">Paiement sécurisé 3D Secure · Visa · Mastercard</span>
                      </div>
                      <div class="d-flex payment-secured align-items-center " :class="isPhone ? 'mt-2' : 'justify-content-end ml-auto'">
                        <img src="../../images/lock_green.svg" class="pr-1" />
                        <span :class="isPhone ? 'raleway-reg-p13' : 'raleway-reg-p15'">Paiement sécurisé</span>
                      </div>
                    </div>
                    <div class="card-stripe mx-auto mb-3 pt-3">
                      <div class="line-form row field">
                        <label for="card-holder" class="col-12">
                          Nom du titulaire de la carte *
                          <input
                            id="card-holder"
                            type="text"
                            placeholder="Nom/Prénom"
                            class="mt-1"
                            v-model="cardDetails.holder"
                          />
                        </label>
                      </div>
                      <div class="line-form row field">
                        <label for="card-number" class="col-12">
                          Numéro de carte *
                          <div id="card-number" class="input empty mt-1"></div>
                        </label>
                      </div>
                      <div class="line-form row mb-2 field">
                        <label for="card-expiry" class="col-12 col-md-6" :class="isPhone ? '' : 'pr-4'">
                          Date d’expiration *
                          <div id="card-expiry" class="input empty mt-1"></div>
                        </label>
                        <label for="card-cvc" class="col-12 col-md-6">
                          CVC *
                          <div id="card-cvc" class="input empty mt-1"></div>
                        </label>
                      </div>
                      <p class="pt-3" :class="isPhone ? 'raleway-reg-p13' : 'mx-4 raleway-reg-p15'">
                        En réservant ce séjour, vous acceptez
                        <a class="link-hortense raleway-semi-p15" href="/politique-confidentialit%C3%A9" target="_blank"
                        >la politique de confidentialité</a
                        >, les
                        <span class="raleway-semi-p15">conditions d'annulation</span>
                        et les
                        <span class="raleway-semi-p15">conditions d'utilisation</span>.
                      </p>
                      <div class="d-flex pt-3" :class="isPhone ? 'w-100' : 'justify-content-center'">
                        <button
                          v-if="!showRoomReselectionCta"
                          class="hortense-btn-primary w-100"
                          :disabled="isProcessingPayment"
                          @click.prevent="handlePayment"
                        >
                          {{ paymentButtonCaption }}
                        </button>
                        <button
                          v-else
                          class="hortense-btn-primary w-100"
                          @click.prevent="redirectToRoomReselection"
                        >
                          Resélectionnez ma chambre
                        </button>
                      </div>
                      <div v-if="this.showPaymentError" class="payment-error-message mt-3 text-center">
                        <p v-if="bookingErrorMessage && bookingErrorMessage != ''"class="raleway-reg-p13 mb-0" style="color: #D56A70;">
                          {{ bookingErrorMessage }}
                        </p>
                        <p class="raleway-reg-p13 mb-0 mt-1" style="color: #D56A70;">
                          Le paiement n'a pas pu aboutir. Aucun débit n'a été effectué. Si le problème persiste, contactez-nous par téléphone au +33 6 26 20 38 46 ou par message sur <a href="https://wa.me/33626203846" target="_blank" rel="noopener noreferrer" style="color: #D56A70; text-decoration: underline;">WhatsApp</a>.
                        </p>
                      </div>
                      <!-- <p class="raleway-reg-p12 pt-4" :class="isPhone ? 'text-start' : 'text-center'">
                        Le montant de votre séjour est à régler en amont ou sur place. En cas de règlement anticipé, l'établissement vous contactera directement. Besoin d'aide ? écrivez-nous
                        <a :href="'/pages/contact/'" class="link-hortense">ici.</a>
                      </p> -->
                    </div>
                  </div>
                  </div><!-- end step-block-content -->
                </div><!-- end step-block step-from-3 -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-5 order-1 order-md-2 col-info-right" :class="!isPhone ? 'pt-5' : ''">
          <div ref="desktopSummaryCard" class="card-resa-sum">
            <div class="d-flex justify-content-start align-items-start mb-3 pt-2" v-if="isPhone" @click="close()">
              <div class="back-button d-flex align-items-center justify-content-center ml-3">
                <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 15px; height: 17.5px;" />
              </div>
            </div>
            <div class="container right-section-p">
              <div class="row align-items-start">
                <div class="col-12 col-md-8 order-1 order-md-2" :class="isPhone ? 'p-0' : ''">
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-column align-items-md-start align-items-center top-text">
                      <p class="merriweather-reg-20 text-center mb-0">Votre réservation</p>
                      <p class="merriweather-reg-28 mb-0 no-translate" :class="isPhone ? 'px-4 text-center mb-4' : ''">
                        {{ `${lodging.name}` }}
                      </p>
                      <div v-if="tripadvisorAllReviews.length > 0" class="ta-global-summary d-flex align-items-center raleway-medi-p18 ml-4">
                        <i class="fa-solid fa-star ta-starr"></i>
                        <span class="raleway-medi-p20 ml-1">{{ (tripadvisorGlobalRating || 5) }}/5</span>
                        <a
                          :href="`/reservation-hotel/${lodging.slug}/avis`"
                          :target="isPhone ? '_self' : '_blank'"
                          :rel="isPhone ? null : 'noopener noreferrer'"
                          class="raleway-reg-p13 ta-muted ml-2"
                          style="cursor:pointer; text-decoration: underline; color: #2C5E4B;"
                        >
                          {{ (tripadvisorAllReviews.length || 0) }} avis
                        </a>
                      </div>
                    </div>
                    <div class="d-flex flex-column" v-if="!isPhone">
                      <div class="d-flex align-items-center">
                        <img src="../../images/icon_calendar.svg" class="pb-1 mr-2" v-set-alt />
                        <p class="raleway-reg-p15 mb-0 reservation-date-line pb-1">
                          Du {{ this.formatReservationDateLine(from) }} au {{ this.formatReservationDateLine(to) }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center my-1">
                        <img src="../../images/profil.svg" class="mr-2" v-set-alt />
                        <p class="raleway-reg-p15 mb-0">
                          <span class="raleway-bold-p15">{{ this.formatAdults().split(" ")[0] }}</span>&nbsp;<span class="raleway-reg-p15">{{ this.formatAdults().split(" ")[1] }}</span> - 
                          <span class="raleway-bold-p15">{{ this.formatChilds().split(" ")[0] }}</span>&nbsp;<span class="raleway-reg-p15">{{ this.formatChilds().split(" ")[1] }}</span>
                        </p>
                      </div>
                      <div class="d-flex w-100 justify-content-between">
                        <div class="d-flex pt-1">
                          <img src="../../images/icon_moon.svg" class="pb-2 mr-2" v-set-alt />
                          <p class="raleway-reg-p15 mb-0">
                            <strong>{{ 
                              isNaN(Math.ceil((this.toDate(this.formatDateKoedia(to)) - this.toDate(this.formatDateKoedia(from))) / (1000 * 60 * 60 * 24))) 
                              ? this.numberOfNights
                              : Math.ceil((this.toDate(this.formatDateKoedia(to)) - this.toDate(this.formatDateKoedia(from))) / (1000 * 60 * 60 * 24)) 
                            }}</strong> {{ this.numberOfNights === 1 ? 'nuit' : 'nuits' }} -
                          </p>
                          <p class="raleway-medi-p15 light-text-color mb-0">&nbsp;{{ pricePerNightHt }}€/par nuit</p>
                        </div>
                        <a class="____link raleway-reg-p15 cursor-pointer" @click="modify()">Modifier</a>
                      </div>
                      <div v-if="this.numberOfNights && this.numberOfNights > 3 && !eventLodging" class="d-flex align-items-start mb-1 mt-1">
                        <i class="fa-solid fa-gift text-green" style="margin-right: 5px;"></i>
                        <div v-if="lodging.lodging_description.green_experience && lodging.lodging_description.green_experience != 'null' && lodging.lodging_description.green_experience != ''" class="raleway-semi-p12 text-green text-uppercase">
                          {{ lodging.lodging_description.green_experience }}
                          <span 
                            class="green-privilege-container ml-1"
                            @mouseenter="showGreenPrivilegeTooltip = true"
                            @mouseleave="showGreenPrivilegeTooltip = false"
                          >
                            <i class="fas fa-info-circle mr-1" style="color: #2C5E4B; font-size: 12px;"></i>
                            <div
                              v-if="showGreenPrivilegeTooltip"
                              class="green-privilege-tooltip raleway-reg-p13 mt-1"
                            >
                              Dès 4 nuits, un privilège exclusif offert par Hortense.
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-4 order-2 order-md-1 card-img" :class="isPhone ? 'px-0' : 'pt-2 px-0'">
                  <img
                    v-if="bookingImageSrc"
                    :src="bookingImageSrc"
                    :alt="bookingImageAlt"
                  />
                  <img
                      v-else
                      src="https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1053&q=80"
                      :alt="bookingImageAlt"
                  />
                </div>

                <div class="col-12 order-3 phone-x-padding pt-4 pb-3" v-if="isPhone">
                  <div class="d-flex align-items-center">
                    <img src="../../images/icon_calendar.svg" class="pb-3 mr-2" v-set-alt />
                    <p class="raleway-reg-p15 mb-0">
                      Du {{ this.formatDate(from) }} au<br> {{ this.formatDate(to) }}
                    </p>
                  </div>
                  <div class="d-flex w-100 justify-content-between">
                    <div class="d-flex pt-1">
                      <img src="../../images/icon_moon.svg" class="pb-4 mr-2" v-set-alt />
                      <p class="raleway-reg-p15 mb-0 text-nowrap">
                        <strong>{{ 
                          isNaN(Math.ceil((this.toDate(this.formatDate(to)) - this.toDate(this.formatDate(from))) / (1000 * 60 * 60 * 24))) 
                          ? this.numberOfNights
                          : Math.ceil((this.toDate(this.formatDate(to)) - this.toDate(this.formatDate(from))) / (1000 * 60 * 60 * 24)) 
                        }}</strong> {{ this.numberOfNights === 1 ? 'nuit' : 'nuits' }} -
                      </p>
                      <p class="raleway-medi-p15 light-text-color mb-0">&nbsp;{{ pricePerNightHt }}€/par nuit</p>
                    </div>
                    <a class="____link raleway-reg-p15 cursor-pointer ml-sm-2" @click="modify()">Modifier</a>
                  </div>
                  <div class="d-flex align-items-center">
                    <img src="../../images/profil.svg" class="pb-3 mr-2" v-set-alt />
                    <p class="raleway-reg-p15">
                      <span class="raleway-bold-p15">{{ this.formatAdults().split(" ")[0] }}</span>&nbsp;<span class="raleway-reg-p15">{{ this.formatAdults().split(" ")[1] }}</span> - 
                      <span class="raleway-bold-p15">{{ this.formatChilds().split(" ")[0] }}</span>&nbsp;<span class="raleway-reg-p15">{{ this.formatChilds().split(" ")[1] }}</span>
                    </p>
                  </div>
                  <div v-if="this.numberOfNights && this.numberOfNights > 3 && !eventLodging" class="d-flex align-items-start mt-1">
                    <i class="fa-solid fa-gift text-green" style="margin-right: 5px;"></i>
                    <div v-if="lodging.lodging_description.green_experience && lodging.lodging_description.green_experience != 'null' && lodging.lodging_description.green_experience != ''" class="raleway-semi-p12 text-green text-uppercase">
                      {{ lodging.lodging_description.green_experience }}
                      <span 
                        class="green-privilege-container ml-1"
                        @mouseenter="showGreenPrivilegeTooltip = true"
                        @mouseleave="showGreenPrivilegeTooltip = false"
                      >
                        <i class="fas fa-info-circle mr-1" style="color: #2C5E4B; font-size: 12px;"></i>
                        <div
                          v-if="showGreenPrivilegeTooltip"
                          class="green-privilege-tooltip raleway-reg-p13 mt-1"
                        >
                          Dès 4 nuits, un privilège exclusif offert par Hortense.
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row border-bottom-gray mt-2" :class="isPhone ? 'phone-x-margin' : ''"></div>
              <div class="row" :class="isPhone ? 'phone-x-padding pt-5' : 'pt-1'">
                <div class="col-12 mb-1 p-0">
                  <span class="raleway-bold-p15 mb-0">
                    {{ bookingHeaderTitle }}
                    <span class="raleway-medi-p15" v-if="!isMultiRoomBooking && singleRoomCapacity"> - Capacité {{ singleRoomCapacity }} personnes</span>
                    <span class="raleway-medi-p15" v-if="!isMultiRoomBooking && board_type"> - {{ board_type }}</span>
                  </span>
                  <p v-if="cancellation_message && accomodationCode && !isMultiRoomBooking" class="raleway-reg-p15 mb-0">
                    {{ cancellation_message }}
                  </p>
                  <p v-if="cancellation_message && !accomodationCode" v-for="(message, idx) in cancellation_message" :key="idx" class="raleway-reg-p15 mb-1">
                    {{ message }}
                  </p>
                  <span
                    v-if="!isMultiRoomBooking && accomodationCode && getRoomStockLeft(item) > 0 && getRoomStockLeft(item) < 5"
                    class="raleway-reg-p12 stock-left-badge d-block mt-1"
                  >
                    PLUS QUE {{ getRoomStockLeft(item) }} CHAMBRE{{ getRoomStockLeft(item) > 1 ? 'S' : '' }} DISPONIBLE{{ getRoomStockLeft(item) > 1 ? 'S' : '' }}
                  </span>
                </div>

                <!-- Per-tariff line items for multi-room bookings -->
                <div v-if="isMultiRoomBooking && selectedTariffRoomBreakdowns.length > 0" class="w-100">
                  <div class="row border-bottom-black" :class="isPhone ? 'phone-x-margin' : ''"></div>
                  <div class="row" :class="isPhone ? 'pt-2 phone-x-padding' : 'pt-2'">
                    <div class="col-12">
                      <p class="raleway-semi-p14 mb-2">Détail des chambres réservées</p>
                    </div>
                  </div>
                  <div
                    v-for="(tariffItem, idx) in selectedTariffRoomBreakdowns"
                    :key="`tariff-${idx}`"
                    class="d-flex flex-column mb-3"
                    :class="isPhone ? 'phone-x-padding' : ''"
                  >
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="d-flex flex-column align-items-start" style="flex: 1;">
                        <p class="raleway-semi-p13 mb-0">
                          x{{ tariffItem.qty }}
                          {{ tariffItem.roomName }}
                        </p>
                        <p
                          v-if="tariffItem.boardType"
                          class="raleway-reg-p12 mb-0"
                          style="color: #707070;"
                        >
                          {{ tariffItem.boardType }}
                        </p>
                      </div>
                      <div class="d-flex flex-column align-items-end ml-2" style="white-space: nowrap;">
                        <p class="raleway-semi-p13 mb-0">
                          {{ formatAmount(tariffItem.unitPricePerNight) }} EUR
                        </p>
                        <p class="raleway-reg-p12 mb-0" style="color: #707070;">par nuit</p>
                        <p class="raleway-semi-p12 mb-0">Total : {{ formatAmount(tariffItem.totalTtc) }}€</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 px-0">
                  <p v-if="lodging.is_entire || !accomodationCode" class="raleway-reg-p15 mb-0">Total HT</p>
                  <p v-if="!accomodationCode" class="raleway-reg-p15 mb-0">Taxe de séjour</p>
                  <p v-if="lodging.is_entire || !accomodationCode" class="raleway-reg-p15 mb-2">TVA</p>
                </div>
                <div class="col-6 px-0 align-right">
                  <div v-if="accomodationCode">
                    <p v-if="lodging.is_entire" class="raleway-reg-p15 mb-0">{{ totalHt }}€</p>
                    <p v-if="lodging.is_entire" class="raleway-reg-p15 mb-0">{{ tva }}€</p>
                  </div>
                  <div v-else>
                    <p class="raleway-reg-p15 mb-0">{{ formatAmount(summaryTotalHt) }}€</p>
                    <p class="raleway-reg-p15 mb-0">{{ formatAmount(summaryTotalTax) }}€</p>
                    <p class="raleway-reg-p15 mb-2">{{ formatAmount(summaryTotalTva) }}€</p>
                  </div>
                </div>
                
              </div>
              <div class="row border-bottom-black" :class="isPhone ? 'phone-x-margin' : ''"></div>
              <div class="row" :class="isPhone ? 'pt-2 phone-x-padding' : 'pt-2'">
                <div class="col-6 px-0">
                  <p class="raleway-medi-p15 mb-2">Montant du séjour</p>
                  <p v-if="!hideTemporarySections" class="raleway-reg-p15 mb-0">Guide de voyage</p>
                  <p v-if="!accomodationCode && lodging.is_entire" class="raleway-reg-p15 mb-0">Frais de ménage</p>
                  <p v-if="!hideTemporarySections" class="raleway-reg-p15">Soutenir le tourisme durable</p>
                </div>
                <div class="col-6 px-0 align-right">
                  <div>
                    <p class="raleway-medi-p15 mb-0">{{ formatAmount(accomodationCode ? totalWithCode : totalWithoutCode) }}€</p>
                    <p v-if="guideChecked" class="raleway-reg-p15 mb-0">15€</p>
                    <p v-else-if="!hideTemporarySections" class="raleway-reg-p15 mb-0">-</p>
                    <p v-if="!accomodationCode && lodging.is_entire && houseHoldFeeAmount > 0" class="raleway-reg-p15 mb-0">{{ houseHoldFeeAmount }}€</p>
                    <p v-else-if="!accomodationCode && lodging.is_entire" class="raleway-reg-p15 mb-0">-</p>
                    <p class="raleway-reg-p15" v-if="compensationPointToEarn > 0  && !hideTemporarySections">{{ compensationPointToEarn }}€</p>
                    <p v-else-if="!hideTemporarySections" class="raleway-reg-p15 mb-0">-</p>
                  </div>
                </div>
              </div>
              <div class="row border-bottom-black" :class="isPhone ? 'phone-x-margin' : ''"></div>
              <div class="row" :class="isPhone ? 'pt-2 phone-x-padding' : 'pt-2'">
                <div class="col-6 px-0">
                  <p class="raleway-bold-p15 mb-0">Montant total TTC</p>
                  <p v-if="selectedSupplements.length > 0" class="raleway-it-l15 mb-0">Services additionnels</p>
                  <p v-if="isPhone" class="text-light-gray raleway-it-l10">Aucun frais de réservation</p>
                </div>
                <div class="col-6 px-0 align-right">
                  <div class="d-flex align-items-center justify-content-end" style="gap: 5px;" v-if="totalDiscountAmount">
                    <div class="raleway-reg-p12 mb-0 discounted-amount text-light-gray">
                      <s>{{ formatAmount(discountedReferenceAmount) }}€</s>
                    </div>
                    <div class="raleway-bold-p15" v-if="totalAmount">
                        {{ totalAmount.toFixed(2) }}€
                    </div>
                    <div class="discount-percentage raleway-medi-p12" v-if="totalDiscountPercentageText != ''">
                      {{ totalDiscountPercentageText }}
                    </div>
                  </div>
                  <div v-else>
                    <p class="raleway-bold-p15 mb-0" v-if="totalAmount">
                      {{ totalAmount.toFixed(2) }}€
                    </p>
                  </div>
                  <p v-if="selectedSupplements.length > 0" class="raleway-it-l15 mb-0">{{ supplementsTotalDisplay }}€</p>
                </div>
                <div class="no-booking-fee w-100 d-flex justify-content-center mt-2" :class="eventLodging ? 'mb-2' : ''" v-if="!isPhone">
                  <p class="raleway-medi-p12 text-center">
                    Aucun frais de réservation
                  </p>
                </div>
                <p v-if="!eventLodging" class="raleway-reg-p12 text-red pt-2 mb-2">
                  Vous réglerez votre séjour directement à l'établissement. Une taxe de séjour, appliquée selon la réglementation locale, pourra être demandée sur place.
                </p>
              </div>
              <div v-if="!isMultiRoomBooking && !gettingRateDetails" class="row info-cancelation mb-3" :class="isPhone ? 'phone-x-margin' : ''">
                <div class="d-flex align-items-center">
                  <img src="../../images/info.svg" v-set-alt />
                  <div class="raleway-bold-p16">Conditions d'annulation</div>
                </div>
                <p class="raleway-reg-p12 pt-1 mb-2">
                  <ul v-if="!isRefundable && (!refund || refund === false)">
                    <li>Tarif non remboursable.</li>
                    <li>En cas d'annulation ou de non présentation, le paiement intégral de la réservation sera dû.</li>
                  </ul>
                  <ul v-else>
                    <li v-if="cancelationPolicy">{{ cancelationPolicy }}</li>
                    <li>
                      En cas d'annulation, après cette date, le paiement intégral de la réservation
                      sera dû.
                    </li>
                  </ul>
                </p>
              </div>
              <!-- NOT KOEDIA -->
              <div v-if="!isMultiRoomBooking && selectedPriceOptionFee" class="row info-cancelation mb-3">
                <div class="d-flex align-items-center">
                  <img src="../../images/info.svg" v-set-alt />
                  <div class="raleway-bold-p16">Conditions d'annulation</div>
                </div>
                <div class="raleway-reg-p12 pt-1">
                  <p class="mb-2">{{ selectedPriceOptionFee }}</p>
                </div>
              </div>
              <div
                v-if="isMultiRoomBooking && multiRoomCancellationPolicies.length > 0"
                class="row info-cancelation mb-3 multi-room-cancellation-section"
                :class="isPhone ? 'phone-x-margin' : ''"
              >
                <div class="d-flex align-items-center mb-2">
                  <img src="../../images/info.svg" v-set-alt />
                  <div class="raleway-bold-p16">Conditions d'annulation</div>
                </div>

                <div class="multi-room-cancellation-list w-100">
                  <div
                    v-for="(policy, index) in multiRoomCancellationPolicies"
                    :key="`multi-room-policy-${index}`"
                    class="multi-room-cancellation-card w-100"
                  >
                    <div class="multi-room-cancellation-line-1">
                      <p class="raleway-semi-p13 mb-0">
                        x{{ policy.qty }} {{ policy.roomName }}
                        <span v-if="policy.boardType" class="raleway-reg-p12 multi-room-cancellation-board-type">- {{ policy.boardType }}</span>
                      </p>
                    </div>
                    <div class="multi-room-cancellation-line-2">
                      <p
                        v-for="(item, itemIndex) in policy.items"
                        :key="`multi-room-policy-item-${index}-${itemIndex}`"
                        class="raleway-reg-p12 mb-0 item"
                      >
                        {{ item }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="reservation-summary-code-stack" :class="isPhone ? 'is-phone' : 'row'">
                <div v-if="!isPhone && showDesktopSummaryScrollCue" class="desktop-summary-scroll-indicator" aria-hidden="true">
                  <span class="raleway-semi-p11">Faites défiler</span>
                  <img src="../../images/arrow-down.svg" alt="" />
                </div>
                <div class="d-flex flex-column promo-container" :class="isPhone ? 'row phone-x-padding' : 'mx-0 w-100'">
                  <label for="code_promo" class="raleway-bold-p12">Code exclusif - carte cadeau</label>
                  <div class="d-flex align-items-center" style="gap: 37px;">
                    <input v-model="code_promo" type="text" class="col-6 col-md-8" :class="{'border-green': loyaltyCodeValidity === 'true' && loyaltyCodeValidity !== 'null', 'border-red': loyaltyCodeValidity === 'false' && loyaltyCodeValidity !== 'null'}"/>
                    <!--<button class="hortense-btn-primary">VALIDER</button>-->
                    <button :disabled="this.isButtonDisabled" style="display:inline;cursor:pointer;" id="code_button" class="hortense-btn-primary w-100" :class="isPhone ? 'mb-3' : ''" @click="checkLoyaltyCode">VALIDER</button>
                  </div>
                  <p v-if="promoDiscountPercentageText != '' && isButtonDisabled" class="raleway-reg-p13 mb-0" style="color: #3B6152">*Votre code exclusif a été appliquée.</p>
                  <p v-else-if="!user && (loyaltyCodeValidity == 'false' || loyaltyCodeValidity === 'null' || loyaltyCodeValidity === 'notvalid') && code_promo != ''" class="raleway-reg-p13 mb-0" style="color: #D56A70;">Veuillez créer un compte client pour bénéficier de l'offre</p>
                  <p v-else-if="loyaltyCodeValidity === 'false' && loyaltyCodeValidity !== 'null'" class="raleway-reg-p13 mb-0" style="color: #D56A70;">L'offre n'est plus valide</p>
                  <div v-else-if="loyaltyCode && loyaltyCodeValidity !== 'null' && loyaltyCodeValidity !== 'notvalid' && loyaltyCodeValidity !== 'false'">
                    <div v-if="loyaltyCode.code_type === 2">
                      <span class="raleway-reg-p13 mb-0" v-if="loyaltyCode.code_type === 2" style="color: #3B6152">Vous bénéficierez de {{ loyaltyCode.code_type_description }} services exclusifs au cours de votre séjour.</span>
                      <ul class="privilege-list">
                        <li
                          v-for="(service, index) in servicesToDisplay"
                          :key="index"
                          :class="{ 'active': service.active, 'locked': !service.active }"
                        >
                          <i :class="service.active ? 'fas fa-check' : 'fas fa-lock'"></i>
                          <span>{{ service.name }}</span>
                        </li>
                      </ul>
                    </div>
                    <span v-if="loyaltyCode.code_type === 1" class="raleway-reg-p13 mb-0">Vous bénéficiez désormais du statut {{ loyaltyCode.code_type_description }}</span>
                  </div>
                  <p v-else-if="loyaltyCodeValidity === 'null'" class="raleway-reg-p13 mb-0" style="color: #D56A70;">*Votre code exclusif est non valide.</p>
                  <p v-else-if="loyaltyCodeValidity === 'notvalid'" class="raleway-reg-p13 mb-0" style="color: #D56A70;">{{ loyaltyCodeErrorMessage }}</p>
                  <div class="d-flex flex-column" v-else-if="loyaltyUser && !loyaltyUser.is_code_used && loyaltyUser.reservations.length == 0">
                    <div class="d-flex align-items-baseline justify-content-start">
                      <div class="icon-exclamation mb-0"><p class="raleway-medi-p8">!</p></div>
                      <p class="mb-0 ml-1 raleway-reg-p11 mt-2" :class="isPhone ? 'ml-1' : ''" style="color: #D56A70;">Veuillez saisir le code exclusif BIENVENUE pour bénéficier de -10 % sur votre 1er séjour.</p><br>
                    </div>
                  </div>
                  <p class="raleway-reg-p11 mt-2 mb-1">Nous contacter : <a :href="`tel:+33626203846`" class="link-hortense" style="color: #3B6152;">+ 33 6 26 20 38 46.</a></p>
                </div>

                <div v-if="!hideTemporarySections" class="row d-flex flex-column promo-container pt-3" :class="isPhone ? 'phone-x-padding' : ''">
                  <label for="code_promo" class="raleway-bold-p12">Code d'activation du coffret cadeau</label>
                  <div class="d-flex align-items-center" style="gap: 37px;">
                    <input v-model="gift_box_promo" type="text" class="col-6 col-md-8" :class="{'border-green': giftBoxCodeValid && giftBoxDiscountAmount > 0, 'border-red': !giftBoxCodeValid && giftBoxCodeValid != null}"/>
                    <!--<button class="hortense-btn-primary">VALIDER</button>-->
                    <button :disabled="this.isGiftBoxButtonDisabled" style="display:inline;cursor:pointer;" id="code_button" class="hortense-btn-primary w-100" :class="isPhone ? 'mb-3' : ''" @click="checkGiftBoxCode">VALIDER</button>
                  </div>
                  <p v-if="giftBoxDiscountPercentageText != '' && isGiftBoxButtonDisabled" class="raleway-reg-p13" style="color: green">*Votre code exclusif a été appliquée.</p>
                  <p v-else-if="giftBoxErrorMessage && giftBoxErrorMessage !== ''" class="raleway-reg-p13" style="color: #D56A70;">{{ giftBoxErrorMessage }}</p>
                  <p v-else-if="gift_box_promo && gift_box_promo !== '' && !giftBoxCodeValid && giftBoxCodeValid != null" class="raleway-reg-p13" style="color: #D56A70;">*Votre code exclusif est non valide.</p>

                </div>
              </div>


              <div class="border-bottom-gray phone-x-margin mt-5" v-if="isPhone"></div>
              <div class="floating-info-anchor d-flex align-items-center justify-content-center">
                <button v-if="isPhone && showFloatingBtn" @click="scrollToSection('steps-container-main')" class="floating-btn text-uppercase raleway-extra-bold-p12 text-nowrap">Renseignez vos informations <img src="../../images/arrow-down.svg" alt="Information"></button>
              </div>
              <div v-if="isPhone && showFloatingMenu && !isKeyboardOpen && !paymentSectionEnabled" class="floating-menu">
                <div class="d-flex flex-column w-100">
                  <div class="floating-menu-header">
                    Aucun frais de réservation
                  </div>
                  <div class="d-flex flex-column w-100 main-content">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center" style="gap: 5px;">
                        <img src="../../images/icon_calendar.svg"style="width: 19px; height: 19px;" />
                        <div class="raleway-reg-p12">
                          Du <span class="raleway-semi-p12">{{formatDateToFrench(from)}}</span> au <span class="raleway-semi-p12">{{ formatDateToFrench(to) }}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center" style="gap: 5px;">
                        <img src="../../images/profil" style="width: 13px; height: 17px;" />
                        <span class="raleway-reg-p12"><span class="raleway-bold-p12">{{ this.formatAdults().split(" ")[0] }}</span> {{ this.formatAdults().split(" ")[1] }} - <span class="raleway-bold-p12">{{ this.formatChilds().split(" ")[0] }}</span> {{ this.formatChilds().split(" ")[1] }}</span>
                      </div>
                    </div>
                    <div class="border-bottom-black my-3"></div>
                    <div>
                      <div class="">
                        <div class="d-flex justify-content-between">
                          <p class="raleway-semi-p15 mb-0">Montant du séjour :</p>
                          <p class="raleway-semi-p12 mb-0">{{ formatAmount(accomodationCode ? totalWithCode : totalWithoutCode) }}€</p>
                        </div>

                        <div v-if="!hideTemporarySections" class="d-flex justify-content-between">
                          <p class="raleway-reg-p15 mb-0">Guide de voyage</p>
                          <p class="raleway-reg-p12 mb-0">{{ guideChecked ? '15€' : '-' }}</p>
                        </div>

                        <div v-if="!accomodationCode && lodging.is_entire" class="d-flex justify-content-between">
                          <p class="raleway-reg-p15 mb-0">Frais de ménage</p>
                          <p class="raleway-reg-p12 mb-0">{{ houseHoldFeeAmount > 0 ? houseHoldFeeAmount + '€' : '-' }}</p>
                        </div>

                        <div v-if="!hideTemporarySections" class="d-flex justify-content-between">
                          <p class="raleway-reg-p15 mb-0">Soutenir le tourisme durable</p>
                          <p class="raleway-reg-p15" v-if="compensationPointToEarn > 0">{{ compensationPointToEarn }}€</p>
                          <p v-else class="raleway-reg-p15 mb-0">-</p>
                        </div>

                        <div class="d-flex justify-content-between">
                          <p class="raleway-bold-p15 mb-0">Montant Total :</p>
                          <div class="d-flex align-items-center gap-2" v-if="totalDiscountAmount">
                            <s class="raleway-reg-p12 text-light-gray mb-0">{{ formatAmount(discountedReferenceAmount) }}€</s>
                            <p class="raleway-semi-p12 mb-0">{{ totalAmount.toFixed(2) }}€</p>
                            <p class="discount-percentage raleway-medi-p12 mb-0" v-if="totalDiscountPercentageText != ''">{{ totalDiscountPercentageText }}</p>
                          </div>
                          <div class="raleway-bold-p15 mb-0" v-else-if="totalAmount">
                            {{ totalAmount.toFixed(2) }}€
                          </div>
                          <p class="raleway-semi-p12 mb-0" v-else>{{ totalAmount.toFixed(2) }}€</p>
                        </div>

                        <div v-if="selectedSupplements.length > 0" class="d-flex justify-content-between mt-1">
                          <p class="raleway-it-l13 mb-0">Services additionnels</p>
                          <p class="raleway-it-l13 mb-0">{{ supplementsTotalDisplay }}€</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fetcher from "packs/shared/api.js";
import Modalsignup from "../../components/modals/Modalsignup.vue";
import DiscountBanner from "../../components/reservations/DiscountBanner.vue";
import ReservationPointsBanner from "../../components/reservations/ReservationPointsBanner.vue";
import SupplementsSelector from "../../components/reservations/SupplementsSelector.vue";
import roomStockMixin from "../../mixins/roomStockMixin";
import { ensureOspitaTrackingId, normalizeRoomPlans, normalizeTariffSelection, withOspitaTrackingId } from "../../utils/reservationFlow";

export default {
  name: "reservation-user-info",
  mixins: [roomStockMixin],
  components: {
    Modalsignup,
    DiscountBanner,
    ReservationPointsBanner,
    SupplementsSelector,
  },
  props: {
    exclusive: Object,
    houseHold: String,
    totalTaxNotKoedia: String,
    totalHtNotKoedia: String,
    totalTtcNotKoedia: String,
    totalTvaNotKoedia: String,
    item: Object,
    lodging: Object,
    from: Date,
    to: Date,
    tax: Object,
    total: Number,
    totalHt: Number,
    pricePerNightHt: Number,
    totalTtc: Number,
    tva: Number,
    user: Object,
    childs: Number,
    adults: Number,
    numberOfNights: Number,
    koediaRoomId: String,
    koediaSessionId: String,
    childrenAges: Array,
    koediaFrom: String,
    koediaTo: String,
    selectedOption: Object,
    accomodationCode: Object,
    selectedPriceOptionFee: String,
    discountPercentage: Number,
    cancellation_message: {
      type: [String, Object],
      default: ''
    },
    board_type: String,
    refund: {
      type: [String, Object, Boolean],
      default: null
    },
    numberOfRooms: {
      type: Number,
      default: 1
    },
    selectedTariffs: {
      type: Array,
      default: () => []
    },
    selectedRooms: {
      type: Array,
      default: () => []
    },
    roomPlans: {
      type: Array,
      default: () => []
    },
    paymentSchedule: {
      type: Object,
      default: null
    },
  },
  beforeDestroy() {
    const tagsAccordions = document.getElementById('tagsAccordions');
    if (tagsAccordions) {
      tagsAccordions.style.display = 'block';
    }
    if (this.isPhone && this.observer && this.$refs.informationSection) {
      this.observer.unobserve(this.$refs.informationSection);
    }
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('resize', this.handleViewportChange);
    window.removeEventListener('resize', this.updateDesktopSummaryScrollCue);
    if (this.$refs.desktopSummaryCard) {
      this.$refs.desktopSummaryCard.removeEventListener('scroll', this.updateDesktopSummaryScrollCue);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.status.createReservation) {
      this.trackPendingReservation()
        .finally(() => next())
    } else {
      next()
    }
  },
  data() {
    return {
      loginUser: null,
      promoDiscountAmount: 0,
      isButtonDisabled: false,
      guideChecked: false,
      houseHoldFeeAmount: 0,
      showModal: false,
      showModalLogin: false,
      loyaltyCode: null,
      loyaltyCodeValidity: String,
      loyalty_token: [],
      loyaltyUser: null,
      // Temporary feature flag to hide sections
      hideTemporarySections: true,
      status: {
        getRateDetails: null,
        createToken: null,
        createCustomer: null,
        addCard: null,
        paymentIntent: null,
        confirmCardPayment: null,
        reqAccomBook: null,
        createReservation: null,
      },
      cardDetails: {
        lastFourDigits: null,
        type: null,
        expiryMonth: null,
        expiryYear: null,
        holder: null,
      },
      showSignupModal: false,
      rateDetails: null,
      paymentIntentId: null,
      reservation: null,
      clientSecret: null,
      displayError: this.$refs.errorsCard,
      card: null,
      stripeKey: document.querySelector("meta[name='stripe-key']").getAttribute("content"),
      stripe: null,
      userInfo: {
        last_name: null,
        first_name: null,
        email: null,
        phone: null,
        city: null,
        country: null,
      },
      specialRequests: '',
      showSpecialRequests: false,
      selectedSupplementsMap: {},
      code_promo: "",
      chatMount: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      bookingRef: null,
      koediaBookingRef: null,
      date: null,
      cvc: null,
      cardToken: null,
      gettingRateDetails: true,
      isProcessingPayment: false,
      isCreatingReservation: false,
      purchaseEventSent: false,
      messageBody: null,
      checkedSales: null,
      evergreens: null,
      showEvergreens: false,
      distanceBetween: 0,
      userLatitude: 0,
      userLongitude: 0,
      compensationToPay: 0,
      guideCompensationToPay: 0,
      compensationPointToEarn: 0,
      informationsCompleted: false,
      step: 1,
      selectedTransportEngin: "plane",
      lodgingMount: null,
      compensationByNightsAndTravelers: {
        compensation_amount: 130,
        compensation_carbon_offset: 22,
      },
      compensationByPlane: {
        compensation_amount: 100,
        compensation_carbon_offset: 22,
      },
      compensationByTrain: {
        compensation_amount: 55,
        compensation_carbon_offset: 22,
      },
      compensationByCar: {
        compensation_amount: 55,
        compensation_carbon_offset: 22,
      },
      totalCompensationCarbonOffset: 0,
      totalCompensationAmount: 0,
      isLoyaltySectionChecked: false,
      isGreenExperienceChecked: false,
      showCarbonOffsetSection: false,
      showFloatingBtn: false,
      observer: null,
      showFloatingMenu: false,
      isKeyboardOpen: false,
      initialViewportHeight: 0,
      step1Completed: false,
      step2Completed: false,
      incompleteInformation: false,
      missingPhoneForLoggedUser: false,
      promoDiscountPercentageText: '',
      lodgingDiscountPercentageText: '',
      lodgingDiscountAmount: 0,
      sessionId: this.generateSessionId(),
      giftBoxDiscountAmount: 0,
      giftBoxDiscountPercentageText: '',
      isGiftBoxButtonDisabled: false,
      bankTransferRequested: false,
      gift_box_promo: '',
      giftBoxCodeValid: null,
      giftBoxErrorMessage: '',
      phoneNotRegistered: false,
      discountCodeValid: null,
      discountCodeAmount: 0,
      discountCodePercentageText: '',
      isDiscountCodeButtonDisabled: false,
      discountCodeErrorMessage: '',
      showPaymentError: false,
      invalidRoomIdErrorActive: false,
      showDesktopSummaryScrollCue: false,
      showGreenPrivilegeTooltip: false,
      showPointsTooltip: false,
      roomInventories: null,
      rooms: [],
      accommodation_code: null,
      inventoriesCacheKey: null,
      inventoriesLoading: false,
      loyaltyCodeServiceCount: 0,
      loyaltyCodeErrorMessage: "Les conditions de l'offre ne sont pas respectées",
      bienvenueAutoApplyAttempted: false,
      bookingErrorMessage: null,
      tariffRateDetailsByIndex: {},
      tariffCancellationOverrides: {},
      tariffSelectedPriceOptionFeeOverrides: {},
      analyticsSentFlags: {
        begin_checkout: false,
        add_personal_info: false,
      },
    };
  },
  watch: {
    cardToken() {
      this.cardDetails.lastFourDigits = this.cardToken.card.last4;
      this.cardDetails.type = this.cardToken.card.brand;
      this.cardDetails.expiryMonth = this.cardToken.card.exp_month;
      this.cardDetails.expiryYear = this.cardToken.card.exp_year;
    },
    code_promo() {
      if (
        this.code_promo === ''
      ) {
        this.isButtonDisabled = false;
        this.resetDiscountState();
        this.loyaltyCodeServiceCount = 0;
      }
    },
    gift_box_promo() {
      if (
        this.gift_box_promo === ''
      ) {
        this.resetGiftBoxDiscountState();
      }
    },
    step1Completed(newVal) {
      if (newVal) {
        this.mountStripeElements();
      }
    },
    step2Completed(newVal) {
      if (newVal) {
        this.mountStripeElements();
      }
    },
  },
  created() {
    if (this.user) {
      if (this.numberOfNights > 3) {
        this.isGreenExperienceChecked = true;
      }
      if (this.user.loyalty_points >= 500) {
        this.isLoyaltySectionChecked = true;
      }
    }

    // Initialize household fee amount from props
    const numHouseHold = Number(this.houseHold);

    if (!isNaN(numHouseHold) && numHouseHold > 0) {
      this.houseHoldFeeAmount = numHouseHold;
    }

    // Initialize accommodation code from props
    if (this.accomodationCode) {
      this.accommodation_code = this.accomodationCode;
    }

    // Initialize rooms array from selected tariffs when available
    const normalizedTariffs = normalizeTariffSelection(this.selectedTariffs);
    if (normalizedTariffs.length > 0 && this.lodging?.rooms) {
      const selectedRoomIds = normalizedTariffs.map(t => t?.roomId).filter(Boolean);
      this.rooms = this.lodging.rooms.filter(r => selectedRoomIds.includes(r.id));
    } else if (this.item) {
      this.rooms = [this.item];
    }
  },
  methods: {
    // Parses a numeric value from discount text like "-10%" or "-15€".
    extractPercentage(text) {
      const match = text?.match(/-?\d+(\.\d+)?/);
      return match ? parseFloat(match[0]) : 0;
    },
    isInvalidRoomIdError(errorMsg) {
      return (errorMsg || '').toString().includes('Invalid room ID');
    },
    setReservationExpiredErrorMessage() {
      this.bookingErrorMessage = 'Votre réservation a expiré car le délai de validation a été dépassé. La chambre sélectionnée a été remise en disponibilité. Veuillez revenir à la page précédente pour finaliser votre réservation.';
      this.invalidRoomIdErrorActive = true;
      this.showPaymentError = true;
    },
    // Loads Koedia room inventories and caches them for the selected date range.
    async fetchInventories() {
      if (!this.accommodation_code || !this.koediaFrom || !this.koediaTo) {
        return;
      }

      const cacheKey = `${this.koediaFrom}-${this.koediaTo}`;

      // Return cached data if available
      if (this.roomInventories && this.inventoriesCacheKey === cacheKey && Object.keys(this.roomInventories).length > 0) {
        return;
      }

      this.inventoriesLoading = true;

      try {
        const response = await fetcher.post(
          `/lodgings/${this.lodging.slug}/get_inventories`,
          {
            start: this.koediaFrom,
            end: this.koediaTo,
          }
        );

        if (response.data && response.data.inventories) {
          this.roomInventories = response.data.inventories;
          this.inventoriesCacheKey = cacheKey;
        }
      } catch (error) {
        console.error('Error fetching inventories:', error);
      } finally {
        this.inventoriesLoading = false;
      }
    },
    // Normalizes Koedia dates into YYYY-MM-DD when input comes as DD/MM/YYYY.
    formatDateKoedia(date) {
      if (date.includes('-') || !date) {
        return date;
      }
      const dateBits = date.split('/');
      return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
    },
    fallbackRoomPlan() {
      return {
        room_count: 1,
        adults: this.adults,
        children: this.childs,
        children_ages: this.normalizedChildrenAges,
      };
    },
    normalizedStoredRoomPlans() {
      return normalizeRoomPlans(this.roomPlans);
    },
    normalizedStoredSelectedRooms() {
      return Array.isArray(this.selectedRooms) ? this.selectedRooms : [];
    },
    storedRoomPlanAt(index) {
      return this.normalizedStoredRoomPlans()[index] || this.fallbackRoomPlan();
    },
    buildKoediaRateDetailsRooms() {
      const selectedRooms = this.normalizedStoredSelectedRooms();
      const storedRoomPlans = this.normalizedStoredRoomPlans();
      let roomPlanIndex = 0;

      if (selectedRooms.length > 0) {
        return selectedRooms.flatMap((selectedRoom) => {
          const qty = Number(selectedRoom?.qty) > 0 ? Number(selectedRoom.qty) : 1;
          const roomIds = Array.isArray(selectedRoom?.room_ids) && selectedRoom.room_ids.length > 0
            ? selectedRoom.room_ids
            : [selectedRoom?.room_id];
          const assignedRoomPlans = normalizeRoomPlans(selectedRoom?.room_plans);

          return roomIds.slice(0, qty).map((roomId, index) => {
            const roomPlan = assignedRoomPlans[index] || storedRoomPlans[roomPlanIndex] || this.fallbackRoomPlan();
            roomPlanIndex += 1;

            return {
              id: this.normalizeKoediaRoomId(roomId),
              children_ages: roomPlan.children_ages,
            };
          });
        }).filter((room) => room.id);
      }

      return this.selectedTariffs.flatMap((tariffItem) => {
        const roomIds = this.extractKoediaRoomIdsFromTariff(tariffItem);
        return roomIds.map((roomId) => {
          const roomPlan = storedRoomPlans[roomPlanIndex] || this.fallbackRoomPlan();
          roomPlanIndex += 1;

          return {
            id: roomId,
            children_ages: roomPlan.children_ages,
          };
        });
      });
    },
    rateDetailsForTariff(rateDetails, index) {
      if (!Array.isArray(rateDetails)) return rateDetails;
      const roomOffset = this.selectedTariffs
        .slice(0, index)
        .reduce((sum, tariffItem) => sum + (Number(tariffItem?.qty) || 1), 0);
      return rateDetails[roomOffset] || rateDetails[index] || rateDetails[0] || null;
    },
    // Toggles travel guide selection and syncs its fixed 15€ contribution.
    handleGuideAcceptanceChange(event) {
      if (event.target.checked) {
        this.guideCompensationToPay += 15
        this.guideChecked = true
      } else {
        this.guideCompensationToPay -= 15
        this.guideChecked = false
      }
    },
    // Returns a SHA-256 hash for analytics-safe email tracking.
    async hashEmail(email) {
      if (email && email !== '') {
        const encoder = new TextEncoder();
        const data = encoder.encode(email);
        const hash = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hash));
        return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
      } else {
        return ""
      }
    },
    // Resets loyalty/promo discount effects and restores booking totals.
    resetDiscountState() {
      if (this.accomodationCode) {
        this.totalTtc = this.totalTtc + this.promoDiscountAmount;
      } else {
        this.totalTtcNotKoedia = this.totalTtcNotKoedia + this.promoDiscountAmount;
      }
      this.promoDiscountAmount = 0;
      this.promoDiscountPercentageText = '';
      this.loyaltyCode = null;
      this.loyaltyCodeValidity = null;
      this.loyaltyCodeErrorMessage = "Les conditions de l'offre ne sont pas respectées";
    },
    // Resets gift-box discount effects and restores booking totals.
    resetGiftBoxDiscountState() {
      if (this.accomodationCode) {
        this.totalTtc = this.totalTtc + this.giftBoxDiscountAmount;
      } else {
        this.totalTtcNotKoedia = this.totalTtcNotKoedia + this.giftBoxDiscountAmount;
      }
      this.giftBoxDiscountAmount = 0;
      this.giftBoxDiscountPercentageText = '';
      this.isGiftBoxButtonDisabled = false;
      this.giftBoxCodeValid = null;
      this.giftBoxErrorMessage = '';
    },
    // Validates and applies loyalty/user discount codes to the current booking totals.
    async checkLoyaltyCode() {
      try {
        const today = new Date();
        
        // First check if it's a user discount code
        if (this.user) {
          try {
            const discountCodeResponse = await fetcher.get(`/user_discount_codes/${this.code_promo}/verify`, {
              params: { user_id: this.user.id }
            });
            
            if (discountCodeResponse.data.valid && parseFloat(discountCodeResponse.data.discount_amount) > 0) {
              if (this.promoDiscountAmount > 0) {
                this.resetDiscountState();
              }

              const discountValue = parseFloat(discountCodeResponse.data.discount_amount);
              const discountType = discountCodeResponse.data.discount_type || 'amount';

              let discountAmount;
              if (discountType === 'percent') {
                // Apply as a percentage of the booking total
                const baseTotal = this.accomodationCode ? this.totalWithCode : this.totalWithoutCode;
                discountAmount = (baseTotal * discountValue) / 100;
                this.promoDiscountPercentageText = `-${discountValue}%`;
              } else {
                // Apply as a fixed euro amount
                discountAmount = discountValue;
                this.promoDiscountPercentageText = `-${parseInt(discountValue)}€`;
              }

              if (this.accomodationCode) {
                this.totalTtc = Math.max(0, this.totalTtc - discountAmount);
              } else {
                this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - discountAmount);
              }
              this.promoDiscountAmount = discountAmount;
              this.isButtonDisabled = true;
              this.loyaltyCodeValidity = 'true';
              return;
            }
          } catch (discountCodeError) {
            // If not a user discount code, continue to check other code types
            console.log('Not a user discount code, checking other types');
          }
        }
        
        const response = await fetcher.get('/user_codes/' + this.code_promo, {
          params: { lodging_slug: this.lodging.slug }
        });
        const codeData = response.data;
        this.loyaltyCode = codeData;

        if (this.promoDiscountAmount > 0 && codeData && this.code_promo.trim() !== '') {
          this.resetDiscountState();
        }
        if (codeData && codeData.activation_code) {
          if (this.accomodationCode) {
            this.totalTtc = Math.max(0, this.totalTtc - parseInt(codeData.amount));
            this.isButtonDisabled = true;
            this.promoDiscountAmount = parseInt(codeData.amount);
          } else {
            this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - parseInt(codeData.amount));
            this.isButtonDisabled = true;
            this.promoDiscountAmount = parseInt(codeData.amount);
          }
          this.promoDiscountPercentageText = `-${codeData.amount}€`;
        } else if (codeData.sponsorship_discount_percentage && codeData.sponsorship_discount_percentage > 0) {
          // Handle sponsorship discount codes
          const sponsorshipDiscountPercentage = parseFloat(codeData.sponsorship_discount_percentage);
          if (this.accomodationCode) {
            const discount = (this.totalWithCode * sponsorshipDiscountPercentage) / 100;
            this.totalTtc = Math.max(0, this.totalTtc - discount);
            this.promoDiscountAmount = discount;
            this.isButtonDisabled = true;
          } else {
            const discount = (this.totalWithoutCode * sponsorshipDiscountPercentage) / 100;
            this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - discount);
            this.promoDiscountAmount = discount;
            this.isButtonDisabled = true;
          }
          this.promoDiscountPercentageText = `-${sponsorshipDiscountPercentage}%`;
          this.loyaltyCodeValidity = 'true';
        } else if (
          codeData.code_status === true &&
          today <= new Date(codeData.expiry_date) &&
          today >= new Date(codeData.validity_date) &&
          !codeData.code_utilization_date
        ) {
          if (codeData.code_name === 'BIENVENUE') {
            if (this.accomodationCode) {
              const discount = (this.totalWithCode * 10) / 100;
              this.totalTtc = Math.max(0, this.totalTtc - discount);
              this.promoDiscountAmount = discount;
              this.isButtonDisabled = true;
            } else {
              const discount = (this.totalWithoutCode * 10) / 100;
              this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - discount);
              this.promoDiscountAmount = discount;
              this.isButtonDisabled = true;
            }
            this.promoDiscountPercentageText = '-10%';
          } else if (codeData.code_type === 6 && codeData.code_type_trigger <= Math.ceil((this.toDate(this.to) - this.toDate(this.from)) / (1000 * 60 * 60 * 24))) {
            const discountPercentage = parseInt(codeData.code_type_description);
            if (this.accomodationCode) {
              const discount = (this.totalWithCode * discountPercentage) / 100;
              this.totalTtc = Math.max(0, this.totalTtc - discount);
              this.promoDiscountAmount = discount;
              this.isButtonDisabled = true;
            } else {
              const discount = (this.totalWithoutCode * discountPercentage) / 100;
              this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - discount);
              this.promoDiscountAmount = discount;
              this.isButtonDisabled = true;
            }
            this.promoDiscountPercentageText = `-${discountPercentage}%`;
          } else if (
            codeData.code_type_trigger <= Math.ceil((this.toDate(this.to) - this.toDate(this.from)) / (1000 * 60 * 60 * 24))
          ) {
            this.loyaltyCodeValidity = 'true';
            if (codeData.code_type === 0) {
              const discount = 50 * parseInt(codeData.code_type_description);
              if (this.accomodationCode) {
                this.totalTtc = Math.max(0, this.totalTtc - discount);
                this.promoDiscountAmount = discount;
                this.isButtonDisabled = true;
              } else {
                this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - discount);
                this.promoDiscountAmount = discount;
                this.isButtonDisabled = true;
              }
              this.promoDiscountPercentageText = `-${discount}€`;
            } else if (codeData.code_type === 2 && this.user) {
              // Handle service count from loyalty code
              const serviceCount = parseInt(codeData.code_type_description);
              this.loyaltyCodeServiceCount = serviceCount;
              this.isButtonDisabled = true;
              console.log('Service count from code:', serviceCount);
            }
          } else {
            this.loyaltyCodeValidity = 'notvalid';
            if (codeData.code_type === 2) {
              this.loyaltyCodeErrorMessage = `Le nombre de nuits minimum est de ${codeData.code_type_trigger}`;
            } else {
              this.loyaltyCodeErrorMessage = "Les conditions de l'offre ne sont pas respectées";
            }
          }
        } else {
          this.loyaltyCodeValidity = 'false';
        }
      } catch (e) {
        this.loyaltyCodeValidity = 'null';
        console.error(e);
      }
    },
    async checkGiftBoxCode() {
      try {
        const res = await fetcher.get(`/gift-box-code/${this.gift_box_promo}/verify`, {
          params: {
            minimum_nights: this.numberOfNights
          }
        });
        const codeData = res.data;
        if (codeData.success.toString() === 'true' && parseFloat(codeData.amount) > 0) {
          this.giftBoxCodeValid = true;
          this.giftBoxDiscountAmount = parseFloat(codeData.amount) || 0;

          if (this.accomodationCode) {
            this.totalTtc = Math.max(0, this.totalTtc - this.giftBoxDiscountAmount);
          } else {
            this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - this.giftBoxDiscountAmount);
          }

          this.giftBoxDiscountPercentageText = `-${parseInt(this.giftBoxDiscountAmount)}€`;
          this.isGiftBoxButtonDisabled = true;
        } else {
          this.giftBoxCodeValid = false;
          this.giftBoxDiscountAmount = 0;
          this.giftBoxDiscountPercentageText = '';
          this.isGiftBoxButtonDisabled = false;

          if (codeData.reason === 'user_not_logged_in') {
            this.giftBoxErrorMessage = codeData.message || "Vous devez créer un compte client pour utiliser votre code.";
          }
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du code cadeau:', error);
        this.giftBoxCodeValid = false;
      }
    },
    async checkDiscountCode() {
      try {
        if (!this.user) {
          this.discountCodeErrorMessage = "Vous devez être connecté pour utiliser un code de réduction personnalisé.";
          this.discountCodeValid = false;
          return;
        }

        const res = await fetcher.get(`/user_discount_codes/${this.code_promo}/verify`, {
          params: {
            user_id: this.user.id
          }
        });
        const codeData = res.data;

        if (codeData.valid && parseFloat(codeData.discount_amount) > 0) {
          this.discountCodeValid = true;
          this.discountCodeAmount = parseFloat(codeData.discount_amount) || 0;

          if (this.accomodationCode) {
            this.totalTtc = Math.max(0, this.totalTtc - this.discountCodeAmount);
          } else {
            this.totalTtcNotKoedia = Math.max(0, this.totalTtcNotKoedia - this.discountCodeAmount);
          }

          this.discountCodePercentageText = `-${parseInt(this.discountCodeAmount)}€`;
          this.isDiscountCodeButtonDisabled = true;
          this.discountCodeErrorMessage = '';
        } else {
          this.discountCodeValid = false;
          this.discountCodeAmount = 0;
          this.discountCodePercentageText = '';
          this.isDiscountCodeButtonDisabled = false;
          this.discountCodeErrorMessage = codeData.message || "Code de réduction invalide ou expiré.";
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du code de réduction:', error);
        this.discountCodeValid = false;
        this.discountCodeErrorMessage = "Erreur lors de la vérification du code.";
      }
    },
    setUser(user) {
      this.user = user;
      this.showModal = false;
      if (user && this.loginUser && user?.id !== this.loginUser?.id) {
        window.location.reload();
      }
    },
    async useLoyaltyCode() {
      try {

        console.log('code_promo');
        console.log(this.code_promo);
        console.log('user_id');
        console.log(this.user);
        const res = await fetcher.patch('/user_codes/1', {
          collection: {
            code_name: this.code_promo,
            user_id: this.user.id,
            code_utilization_date: new Date().toISOString().slice(0, 10)
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
    async sendMessage() {
      try {
        console.log(this.user);
        const res = await fetcher.post("/chat_rooms", {
          receiver_id: this.lodging.user_id,
          object: "client",
        });
        this.chatMount = res.data;
        console.log(res.data);
        const resMessage = await fetcher.post("/chat_rooms/" + this.chat_room.id + "/messages", {
          message: this.messageBody,
        });
        this.chatMount.messages.push(resMessage.data);
        this.newMessage.body = "";
      } catch (e) {
        console.error(e);
      }
    },
    close() {
      this.$emit("closed");
      window.location.href = `/reservation-hotel/${this.lodging.slug}?modify=true`;
    },
    modify() {
      window.location.href = `/reservation-hotel/${this.lodging.slug}?modify=true`;
    },
    redirectToRoomReselection() {
      const adultsCount = Number.isFinite(Number(this.adults)) ? parseInt(this.adults, 10) : 2;
      const childsCount = Number.isFinite(Number(this.childs)) ? parseInt(this.childs, 10) : 0;

      const state = {
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        from: this.koediaFrom,
        to: this.koediaTo,
        adults: adultsCount,
        childs: childsCount,
      };

      localStorage.setItem('reservationState', JSON.stringify(state));
      window.location.href = `/reservation-hotel/${this.lodging.slug}`;
    },
    // Mounts Stripe Elements for secure card number, expiry, and CVC inputs.
    async mountStripeElements() {
      await this.$nextTick();

      if (!document.querySelector("#card-number")) {
        console.warn("Stripe input fields not found in DOM yet");
        return;
      }

      if (!this.stripe) {
        this.stripe = Stripe(this.stripeKey);
      }

      const elements = this.stripe.elements();

      const elementStyles = {
        base: {
          color: "rgba(0, 0, 0, 0.9)",
          fontWeight: "600",
          fontSize: "12px",
          fontFamily: "Raleway, sans-serif",
          fontStyle: "normal",
          lineHeight: "18px",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: "600",
          },
          ":-webkit-autofill": {
            color: "rgba(0, 0, 0, 0.5)",
          },
        },
        invalid: {
          color: "#E25950",
          "::placeholder": {
            color: "#FFCCA5",
          },
        },
      };

      const elementClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid",
      };

      this.cardNumber = elements.create("cardNumber", {
        style: elementStyles,
        classes: elementClasses,
      });
      this.cardNumber.mount("#card-number");

      this.cardExpiry = elements.create("cardExpiry", {
        style: elementStyles,
        classes: elementClasses,
      });
      this.cardExpiry.mount("#card-expiry");

      this.cardCvc = elements.create("cardCvc", {
        style: elementStyles,
        classes: elementClasses,
      });
      this.cardCvc.mount("#card-cvc");

      this.displayError = this.$refs.errorsCard || {};
    },
    resetStripeElements() {
      // Clear error message
      if (this.displayError) {
        this.displayError.textContent = "";
      }
      this.status = {
        getRateDetails: this.status.getRateDetails,
        createToken: null,
        createCustomer: null,
        addCard: null,
        paymentIntent: null,
        confirmCardPayment: null,
        reqAccomBook: null,
        createReservation: null,
      };
    },
    // Requests Koedia accommodation booking and captures booking references.
    async ReqAccomBook() {
      try {
        const selectedRooms = this.normalizedStoredSelectedRooms();
        const expandedRoomPlans = this.normalizedStoredRoomPlans();

        const hasMultiRoomPayload = selectedRooms.length > 0;
        const roomCount = hasMultiRoomPayload
          ? selectedRooms.reduce((sum, item) => sum + (Number(item?.qty) || 1), 0)
          : 1;

        const roomPlans = hasMultiRoomPayload
          ? expandedRoomPlans
          : [];

        const rooms = hasMultiRoomPayload
          ? selectedRooms.flatMap((item) => {
              const qty = Number(item?.qty) || 1;
              const roomIds = Array.isArray(item?.room_ids) && item.room_ids.length > 0
                ? item.room_ids
                : [item.room_id];
              const assignedRoomPlans = normalizeRoomPlans(item?.room_plans).slice(0, qty);

              return roomIds.slice(0, qty).map((roomId, index) => {
                const roomPlan = assignedRoomPlans[index] || this.storedRoomPlanAt(index);
                return {
                  room_id: String(roomId),
                  koedia_room_id: String(roomId),
                  adults: roomPlan.adults,
                  children: roomPlan.children,
                  children_ages: roomPlan.children_ages,
                  first_name: this.userInfo.first_name,
                  last_name: this.userInfo.last_name,
                };
              });
            })
          : [];

        const payload = {
          koedia_session_id: this.koediaSessionId,
          koedia_room_id: this.resolvePrimaryKoediaRoomId() || selectedRooms[0]?.room_id || null,
          start: this.koediaFrom,
          end: this.koediaTo,
          first_name: this.userInfo.first_name,
          last_name: this.userInfo.last_name,
          adults: this.adults,
          children: this.childs,
          children_ages: this.normalizedChildrenAges,
          email: this.userInfo.email,
          accommodation_code: this.accomodationCode,
          selected_rooms: selectedRooms,
          room_count: roomCount,
          room_plans: roomPlans,
          rooms: rooms,
          ospita_tracking_id: ensureOspitaTrackingId(),
          // card_details: this.cardDetails,
        };

        const res = await fetcher.post(
          `/lodgings/${this.lodging.slug}/request_accommodation_booking`,
          payload
        );
        
        // Update session ID if it was regenerated
        if (res.data.new_session_id) {
          console.log('Session was regenerated. Old session:', this.koediaSessionId);
          console.log('New session:', res.data.new_session_id);
          this.koediaSessionId = res.data.new_session_id;
        }
        
        if (res.data.error) {
          this.status.reqAccomBook = false;
          this.setErrorMessage('ReqAccomBook', res.data.error);
          // Check if error matches the specific room capacity error
          if (res.data.error === 'Attempt to book a room that does not correspond to that requested.') {
            this.bookingErrorMessage = 'Le nombre de voyageurs indiqué dépasse la capacité maximale de cette chambre.\nNous vous invitons à réserver une chambre supplémentaire ou à sélectionner un hébergement plus spacieux pour accueillir l\'ensemble des voyageurs.';
            this.showPaymentError = true;
          } else if (this.isInvalidRoomIdError(res.data.error)) {
            this.setReservationExpiredErrorMessage();
          }
        } else {
          this.status.reqAccomBook = true;
          this.koediaBookingRef =
            res.data.booking_request.book_accommodation_response.accom_book_desc.book_item[
            "@bookingref"
            ];

          console.log("REF BOOK");
          console.log(this.koediaBookingRef);
          this.bookingRef =
            res.data.booking_request.book_accommodation_response.accom_book_desc.book_item[
            "@customerbookingref"
            ];
        }
      } catch (e) {
        this.status.reqAccomBook = false;
        const errorMsg = e?.response?.data?.message || e?.message || 'Failed to request accommodation booking';
        this.setErrorMessage('ReqAccomBook', errorMsg);
        if (this.isInvalidRoomIdError(errorMsg)) {
          this.setReservationExpiredErrorMessage();
        }
      }
    },
    // Persists the final reservation and triggers checkout analytics on success.
    async createReservation() {
      if (this.isCreatingReservation || this.purchaseEventSent) {
        return;
      }

      this.isCreatingReservation = true;

      try {
        let exclusiveOffer = "";
        if (this.exclusive) {
          exclusiveOffer = this.exclusive.title
        }
        let cancel_conditions = "Frais d'annulation de 30% jusqu'à 21 jours avant l'arrivée. Au-delà de 21 jours ou en cas de non-présentation, les frais d'annulation s'élèvent à 100%."

        if (!this.gettingRateDetails) {
          if (!this.isRefundable) {
            cancel_conditions = "En cas d'annulation ou de non présentation, le paiement intégral de la réservation sera dû."
          } else if (this.cancelationPolicy) {
            cancel_conditions = `${this.cancelationPolicy} En cas d'annulation, après cette date, le paiement intégral de la réservation sera dû.`;
          }
        }

        if (this.selectedPriceOptionFee) {
          cancel_conditions = this.selectedPriceOptionFee
        }

        const res = await fetcher.post("/reservation-hotel/" + this.lodging.id + "/reservations", {
          lodging_id: this.lodging.id,
          session_id: this.sessionId,
          is_phone: this.isPhone,
          ospita_tracking_id: ensureOspitaTrackingId(),
          reservation: {
            room_code: this.singleRoomCode,
            checkin: this.from,
            check_out: this.to,
            total: this.totalAmount.toFixed(2),
            partner_discount_percentage: this.discountPercentage,
            duration: this.numberOfNights,
            payment_id: this.paymentIntentId,
            client_secret: this.clientSecret,
            booking_ref: this.bookingRef,
            koedia_booking_ref: this.koediaBookingRef,
            promo_code: this.code_promo,
            tva: this.tax?.tourist_tax,
            accommodation_code: this.accomodationCode,
            offer: exclusiveOffer,
            room_name: this.singleRoomName,
            loyalty_token: this.tokenToResa,
            adults: this.adults,
            childs: this.childs,
            children_ages: this.normalizedChildrenAges,
            cancel_conditions: cancel_conditions,
            discount: this.totalDiscountAmount,
            cancellation_message: this.cancellation_message,
            board_type: this.board_type,
            gift_box_promo: this.gift_box_promo,
            gift_box_discount_amount: this.giftBoxDiscountAmount,
            guide_de_voyage: this.guideChecked ? 15.0 : 0,
            carbon_offset: this.compensationToPay || 0,
            house_hold_fee: this.houseHoldFeeAmount || 0,
            total_tva: this.accomodationCode ? this.tva : this.totalTvaNotKoedia,
            total_tax: this.accomodationCode ? this.tax?.tourist_tax : parseFloat(this.totalTaxNotKoedia),
            special_requests: this.specialRequests + this.supplementsTextForEmail,
            supplement_schedules: this.selectedSupplementsSchedulePayload,
            bank_transfer_requested: this.eventLodging && this.bankTransferRequested,
            ospita_tracking_id: ensureOspitaTrackingId(),
            room_lines: this.buildRoomLines(cancel_conditions),
          },
          user: this.userInfo,
        });
        if (this.code_promo.length > 0 && this.loyaltyCodeValidity === 'true') {
          this.useLoyaltyCode();
        }
        this.reservation = res.data;
        this.status.createReservation = true;
        let bookingWindow = null;

        if (this.from) {
          const dateIn = new Date(`${this.from}`);
          const today = new Date();
          const timeDifference = dateIn - today;
          bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        }
        const lodgingTypeMapping = {
          Hotel: "hôtels",
          "Maison et Villa": "maisons et villas",
          Guestroom: "chambres d'hôtes",
          Lodge: "lodges et lieux insolites",
          Appartment: "appartements",
          Chalet: "chalets"
        };
        let items = [{
          item_name: this.lodging.name,
          item_id: this.lodging.id,
          price: parseFloat((this.accomodationCode && this.loyalty_token?.length === 0) ? this.totalTtc : (this.accomodationCode && this.loyalty_token?.length != 0) ? this.totalTtcLoyalty : this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia),
          item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
          item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie',
          item_category: 'Nos hébergements',
          item_variant: lodgingTypeMapping[this.lodging.type] || "hôtels",
          item_category2: 'Nos hébergements',
          quantity: 1
        }];
        if (this.guideChecked) {
          items.push({
            item_name: 'Guide de voyage',
            item_id: this.lodging.id,
            item_category: 'Guide de voyage',
            price: 15,
            quantity: 1
          });
        }
        const guideValue = this.guideChecked ? 15.0 : 0.0
        if (!this.purchaseEventSent) {
          window.dataLayer = window.dataLayer || [];
          const txnId = String(Math.floor(1e11 + Math.random() * 9e11));
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
              currency: 'EUR',
              transaction_id: txnId,
              discount: this.totalDiscountAmount,
              coupon: this.loyaltyCodeValidity === 'true' ? this.code_promo : null,
              value: parseFloat((this.accomodationCode && this.loyalty_token?.length === 0) ? this.totalTtc : (this.accomodationCode && this.loyalty_token?.length != 0) ? this.totalTtcLoyalty : this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia) + guideValue,
              number_of_nights: this.numberOfNights || 1,
              date_in: this.formatDateSyntax(this.toDate(this.from)),
              date_out: this.formatDateSyntax(this.toDate(this.to)),
              number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
              number_of_adult: this.adults || 0,
              number_of_child: this.childs || 0,
              booking_window: bookingWindow || 2,
              quantity: 1,
              method: 'Visa',
              items: items,
            },
          });
          this.purchaseEventSent = true;
        }
        const encodedReservationId = btoa(this.reservation.id.toString());
        Turbolinks.visit("/reservation-hotel/" + this.lodging.slug + "/reservations/confirmation?reservation_id=" + encodedReservationId);
      } catch (e) {
        this.status.createReservation = false;
        console.log("Failed createReservation");
        console.error(e);
      } finally {
        this.isCreatingReservation = false;
      }
    },
    // Fetches Koedia rate details used for refundable/cancellation and pricing metadata.
    getRateDetails() {
      if (this.accomodationCode) {
        this.gettingRateDetails = true;

        const hasTariffs = Array.isArray(this.selectedTariffs) && this.selectedTariffs.length > 0;

        if (hasTariffs) {
          this.tariffRateDetailsByIndex = {};
          this.tariffCancellationOverrides = {};
          this.tariffSelectedPriceOptionFeeOverrides = {};

          let firstSuccessRateDetails = null;
          const missingIndexes = [];

          this.selectedTariffs.forEach((tariffItem, index) => {
            const prepared = tariffItem?.priceData?.preparedRateDetails || null;
            const preparedDetails = prepared?.rawRateDetails || null;
            const preparedItems = this.normalizeCancellationItems(prepared?.cancellationItems);
            const preparedFee = prepared?.selectedPriceOptionFee || tariffItem?.priceData?.selectedPriceOptionFee || tariffItem?.tariff_cancel_feed || null;

            if (preparedDetails) {
              this.$set(this.tariffRateDetailsByIndex, index, preparedDetails);
              if (!firstSuccessRateDetails) {
                firstSuccessRateDetails = preparedDetails;
              }
            }

            if (preparedItems.length > 0) {
              this.$set(this.tariffCancellationOverrides, index, preparedItems);
            }

            if (preparedFee) {
              this.$set(this.tariffSelectedPriceOptionFeeOverrides, index, preparedFee);
            }

            const hasPreparedPayload = !!preparedDetails || preparedItems.length > 0 || !!preparedFee;
            if (!hasPreparedPayload) {
              missingIndexes.push(index);
            }
          });

          const packageRooms = this.isMultiRoomBooking ? this.buildKoediaRateDetailsRooms() : [];

          if (missingIndexes.length === 0 && packageRooms.length <= 1) {
            this.rateDetails = firstSuccessRateDetails;
            this.status.getRateDetails = !!firstSuccessRateDetails;
            this.gettingRateDetails = false;
            return;
          }

          if (packageRooms.length > 1) {
            const selectedRooms = this.normalizedStoredSelectedRooms();
            const possibilityKey = selectedRooms.find((room) => room?.possibility_key)?.possibility_key || null;

            fetcher
              .post(`/lodgings/${this.lodging.slug}/get_rate_details`, {
                koedia_session_id: this.koediaSessionId,
                koedia_room_id: packageRooms[0].id,
                start: this.koediaFrom,
                end: this.koediaTo,
                rooms: packageRooms,
                selected_rooms: selectedRooms,
                room_plans: this.normalizedStoredRoomPlans(),
                possibility_key: possibilityKey,
                ospita_tracking_id: ensureOspitaTrackingId(),
              })
              .then((res) => {
                const packageRateDetails = res.data.get_rate_details_response.res_get_rate_details;
                let firstPackageRateDetails = null;

                this.selectedTariffs.forEach((tariffItem, index) => {
                  const details = this.rateDetailsForTariff(packageRateDetails, index);
                  if (!details) return;

                  if (!firstPackageRateDetails) firstPackageRateDetails = details;
                  this.$set(this.tariffRateDetailsByIndex, index, details);

                  const cancellationItems = this.buildCancellationItemsFromRateDetails(details, tariffItem);
                  if (cancellationItems.length > 0) {
                    this.$set(this.tariffCancellationOverrides, index, cancellationItems);
                  }

                  const selectedFee = tariffItem?.priceData?.selectedPriceOptionFee || tariffItem?.tariff_cancel_feed || null;
                  if (selectedFee) {
                    this.$set(this.tariffSelectedPriceOptionFeeOverrides, index, selectedFee);
                  }
                });

                this.rateDetails = firstPackageRateDetails;
                this.status.getRateDetails = !!firstPackageRateDetails;
              })
              .catch((e) => {
                this.status.getRateDetails = false;
                console.log("Failed getRateDetails for selected room possibility");
                console.log(e);
              })
              .finally(() => {
                this.gettingRateDetails = false;
              });

            return;
          }

          const requests = missingIndexes.map((index) => {
            const tariffItem = this.selectedTariffs[index];
            const roomId = this.extractKoediaRoomIdsFromTariff(tariffItem)[0];
            const roomPlan = this.storedRoomPlanAt(index);

            if (!roomId) {
              return Promise.resolve({ index, success: false, details: null });
            }

            return fetcher
              .post(`/lodgings/${this.lodging.slug}/get_rate_details`, {
                koedia_session_id: this.koediaSessionId,
                koedia_room_id: roomId,
                start: this.koediaFrom,
                end: this.koediaTo,
                adults: roomPlan.adults,
                children: roomPlan.children,
                children_ages: roomPlan.children_ages,
                room_plans: [roomPlan],
                ospita_tracking_id: ensureOspitaTrackingId(),
              })
              .then((res) => ({
                index,
                success: true,
                details: res.data.get_rate_details_response.res_get_rate_details,
              }))
              .catch((error) => ({ index, success: false, details: null, error }));
          });

          Promise.all(requests)
            .then((results) => {
              results.forEach((result) => {
                if (!result.success || !result.details) return;

                if (!firstSuccessRateDetails) {
                  firstSuccessRateDetails = result.details;
                }

                this.$set(this.tariffRateDetailsByIndex, result.index, result.details);

                const tariffItem = this.selectedTariffs[result.index] || null;
                const cancellationItems = this.buildCancellationItemsFromRateDetails(result.details, tariffItem);
                if (cancellationItems.length > 0) {
                  this.$set(this.tariffCancellationOverrides, result.index, cancellationItems);
                }

                const selectedFee = tariffItem?.priceData?.selectedPriceOptionFee || tariffItem?.tariff_cancel_feed || null;
                if (selectedFee) {
                  this.$set(this.tariffSelectedPriceOptionFeeOverrides, result.index, selectedFee);
                }
              });

              this.rateDetails = firstSuccessRateDetails;
              this.status.getRateDetails = !!firstSuccessRateDetails;
            })
            .catch((e) => {
              this.status.getRateDetails = false;
              console.log("Failed getRateDetails");
              console.log(e);
            })
            .finally(() => {
              this.gettingRateDetails = false;
            });

          return;
        }

        const roomId = this.resolvePrimaryKoediaRoomId();
        if (!roomId) {
          this.gettingRateDetails = false;
          this.status.getRateDetails = false;
          return;
        }

        fetcher
          .post(`/lodgings/${this.lodging.slug}/get_rate_details`, {
            koedia_session_id: this.koediaSessionId,
            koedia_room_id: roomId,
            start: this.koediaFrom,
            end: this.koediaTo,
            adults: this.adults,
            children: this.childs,
            children_ages: this.normalizedChildrenAges,
            ospita_tracking_id: ensureOspitaTrackingId(),
          })
          .then((res) => {
            this.rateDetails = res.data.get_rate_details_response.res_get_rate_details;
            this.gettingRateDetails = false;
            this.status.getRateDetails = true;
          })
          .catch((e) => {
            this.status.getRateDetails = false;
            this.gettingRateDetails = false;
            console.log("Failed getRateDetails");
            console.log(e);
          });
      }
    },
    connectModal() {
      if (!this.user) {
        this.showModalLogin = true;
        this.showModal = true;
      }
    },
    signupModal() {
      if (!this.user) {
        this.showModalLogin = false;
        this.showModal = true;
      }
    },
    reservationTrackingKey(eventName) {
      return [
        'reservation_tracking',
        eventName,
        this.lodging?.id || 'unknown_lodging',
        this.formatDateKoedia(this.from || ''),
        this.formatDateKoedia(this.to || ''),
      ].join('__');
    },
    shouldSendReservationEventOnce(eventName) {
      if (this.analyticsSentFlags[eventName]) return false;

      const key = this.reservationTrackingKey(eventName);
      if (window.sessionStorage.getItem(key)) {
        this.analyticsSentFlags[eventName] = true;
        return false;
      }

      this.analyticsSentFlags[eventName] = true;
      window.sessionStorage.setItem(key, '1');
      return true;
    },
    async fetchLoyaltyUser() {
      try {
        if (this.user) {
          const res = await fetcher.get(`/loyalty_status/${this.user.id}`);
          if (res.data?.id) {
            // Filter reservations to only include confirmed ones
            const confirmedReservations = (res.data.reservations || []).filter(
              reservation => reservation.confirm === true && reservation.cancel !== true
            );
            this.loyaltyUser = {
              ...res.data,
              reservations: confirmedReservations
            };
            await this.tryAutoApplyBienvenueCode();
          } else {
            this.loyaltyUser = null;
          }
          console.log('loyaltyUser', this.loyaltyUser);
        }
      } catch (e) {
        console.error('Error fetching loyalty user:', e);
      }
    },
    async tryAutoApplyBienvenueCode() {
      if (this.bienvenueAutoApplyAttempted) {
        return;
      }

      this.bienvenueAutoApplyAttempted = true;

      if (!this.user || !this.loyaltyUser) {
        return;
      }

      if (this.loyaltyUser.is_code_used) {
        return;
      }

      if ((this.code_promo || '').trim() !== '') {
        return;
      }

      if (this.isButtonDisabled || this.promoDiscountAmount > 0) {
        return;
      }

      this.code_promo = 'BIENVENUE';
      await this.checkLoyaltyCode();
    },
    async fetchUser() {
      try {
        if (this.user) {
          const res = await fetcher.get(`/dashboard/${this.user.id}`);
          this.userInfo = res.data;

          const hasMandatoryInfo =
            !!this.userInfo.first_name &&
            !!this.userInfo.last_name &&
            !!this.userInfo.email &&
            !!this.userInfo.phone &&
            String(this.userInfo.phone).length >= 10;

          if (!this.informationsCompleted && this.step === 1 && hasMandatoryInfo) {
            this.changeStep(1, true);
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateLoyaltyPoints(type) {
      try {
        let new_points = 0;
        // if true using loyalty code
        // false without using loyalty code
        if (type && this.loyaltyCodeValidity === 'true') {
          new_points = this.loyaltyUser.loyalty_points + this.pointsDiff - 500;
        } else {
          new_points = this.loyaltyUser.loyalty_points + this.pointsDiff;
        }
        console.log('Points');
        console.log(new_points);
        if (this.user) {
          const res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_points: new_points } });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateUserStatusByCode(status) {
      try {
        const res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_status: status } });
      } catch (e) {
        console.error(e);
      }
    },
    async updateUserTokenByCode(token) {
      try {
        let res = null;
        if (token === 1) {
          res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_first_token: token + this.userInfo.loyalty_first_token } });
        } else if (token === 2) {
          res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_second_token: token + this.userInfo.loyalty_second_token } });
        } else if (token === 3) {
          res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_third_token: token + this.userInfo.loyalty_third_token } });
        } else if (token === 4) {
          res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_fourth_token: token + this.userInfo.loyalty_fourth_token } });
        } else if (token === 5) {
          res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_fifth_token: token + this.userInfo.loyalty_fifth_token } });
        } else if (token === 6) {
          res = await fetcher.patch(`/dashboard/${this.user.id}`, { user: { loyalty_sixth_token: token + this.userInfo.loyalty_sixth_token } });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async addNewSripeCard() {
      try {
        const response = await fetcher.post("/add_card", {
          card_token: this.cardToken.id,
          stripe_customer_id: this.userInfo.stripe_customer_id
        });
        if (response.data.error) {
          const errorMsg = response.data.error;
          this.setErrorMessage('addNewSripeCard', errorMsg);
          this.status.addCard = false;
          await this.translateAndSetBookingError(errorMsg);
        } else {
          this.status.addCard = true;
          this.showPaymentError = false;
        }
      } catch (e) {
        this.status.addCard = false;
        const errorMsg = e?.message || 'Failed to add card';
        this.setErrorMessage('addNewSripeCard', errorMsg);
        await this.translateAndSetBookingError(errorMsg);
      }
    },
    async initCreateCardToken() {
      try {
        const response = await this.stripe.createToken(this.cardNumber);
        if (response.error) {
          this.status.createToken = false;
          const errorMsg = response.error.message || 'Failed to create card token';
          this.setErrorMessage('initCreateCardToken', errorMsg);
          await this.translateAndSetBookingError(errorMsg);
        } else {
          this.status.createToken = true;
          this.showPaymentError = false;
          this.cardToken = response.token;
        }
      } catch (e) {
        this.status.createToken = false;
        const errorMsg = e?.message || 'Failed to create card token';
        this.setErrorMessage('initCreateCardToken', errorMsg);
        await this.translateAndSetBookingError(errorMsg);
      }
    },
    async initCreateStripeCustomer() {
      try {
        const createCustomerResponse = await fetcher.post("/create_customer", {
          card_token: this.cardToken,
          user: this.userInfo,
        });
        this.status.createCustomer = true;
        this.userInfo.stripe_customer_id = createCustomerResponse.data.stripe_customer_id;
        this.showPaymentError = false;
      } catch (e) {
        this.status.createCustomer = false;
        // Backend returns { error: "..." } for Stripe::CardError — read .error first, then fallback
        const errorMsg = e?.response?.data?.error || e?.response?.data?.message || e?.message || 'Failed to create Stripe customer';
        this.setErrorMessage('initCreateStripeCustomer', errorMsg);
        await this.translateAndSetBookingError(errorMsg);
      }
    },
    async initPaymentIntent() {
      try {
        const response = await fetcher.post("/payment_intents", {
          lodging_id: this.lodging.slug,
          room_id: this.isMultiRoomBooking ? null : (this.singleRoom && this.singleRoom.is_entire ? null : this.singleRoom?.id),
          stripe_customer_id: this.userInfo.stripe_customer_id,
          reservation: {
            checkin: this.from,
            check_out: this.to,
            // For event lodgings with payment schedules, charge only today's online amount.
            // For event lodgings without schedule, charge full booking amount.
            // For regular lodgings, only charge carbon offset / guide add-ons.
            amount_carbon_offset: this.eventLodging
              ? (this.paymentSchedule
                ? parseFloat(this.scheduleOnlineAmount)
                : parseFloat(this.totalAmount.toFixed(2)))
              : this.totalCompensationWithGuide,
          },
          user: this.userInfo,
        });
        this.status.paymentIntent = true;
        this.showPaymentError = false;
        this.paymentIntentId = response.data.payment_intent_id;
        this.clientSecret = response.data.client_secret;
      } catch (e) {
        this.status.paymentIntent = false;
        const errorMsg = e?.response?.data?.message || e?.message || 'Failed to create payment';
        this.setErrorMessage('initPaymentIntent', errorMsg);
        await this.translateAndSetBookingError(errorMsg);
      }
    },
    async initConfirmCardPayment() {
      try {
        const response = await this.stripe.confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.cardNumber,
          },
        });
        if (response.error) {
          this.status.confirmCardPayment = false;
          const errorMsg = response.error.message || 'Card payment confirmation failed';
          this.setErrorMessage('initConfirmCardPayment', errorMsg);
          await this.translateAndSetBookingError(errorMsg);
        } else {
          this.showPaymentError = false;
          this.status.confirmCardPayment = true;
        }
      } catch (e) {
        this.status.confirmCardPayment = false;
        const errorMsg = e?.message || 'Failed to confirm card payment';
        this.setErrorMessage('initConfirmCardPayment', errorMsg);
        await this.translateAndSetBookingError(errorMsg);
      }
    },
    // Sets a stable user-facing error once and always logs full technical context.
    setErrorMessage(functionName, errorMessage) {
      const message = `[${functionName}] ${errorMessage}`;

      // Ensure displayError exists as an object with textContent
      if (!this.displayError) {
        this.displayError = { textContent: '' };
      }

      // Only set the error message if displayError is currently blank or null
      // This prevents overwriting an existing error message
      if (!this.displayError.textContent || this.displayError.textContent.trim() === '') {
        this.displayError.textContent = message;
      }

      // Always log to console
      console.error(message);
    },
    async translateAndSetBookingError(errorMsg) {
      // Translate the error message to French and set as bookingErrorMessage
      if (this.isInvalidRoomIdError(errorMsg)) {
        this.setReservationExpiredErrorMessage();
        return;
      }

      try {
        const savedLanguage = localStorage.getItem('pageLanguage');
        const translationResponse = await fetcher.post('/api/translate', {
          text: `${errorMsg}`,
          target_language: savedLanguage || 'fr'
        });
        const translatedMessage = translationResponse.data.translated_text || errorMsg;

        if (this.isInvalidRoomIdError(translatedMessage)) {
          this.setReservationExpiredErrorMessage();
          return;
        }

        this.invalidRoomIdErrorActive = false;
        this.bookingErrorMessage = translatedMessage;
        this.showPaymentError = true;
      } catch (translationError) {
        console.error('Translation error:', translationError);
        // Fallback to original error message if translation fails
        this.invalidRoomIdErrorActive = false;
        this.bookingErrorMessage = errorMsg;
        this.showPaymentError = true;
      }
    },
    // Runs the full payment/reservation pipeline with guarded status checks.
    async handlePayment() {
      if (this.isProcessingPayment) return;

      if (!this.canSubmitPayment) {
        this.missingPhoneForLoggedUser = !!(this.user && !this.userInfo.phone);
        this.incompleteInformation = !this.missingPhoneForLoggedUser;
        this.scrollToSection('steps-container-main');
        return;
      }

      this.displayError.textContent = "";
      this.invalidRoomIdErrorActive = false;
      this.isProcessingPayment = true;

      await this.initCreateCardToken();

      if (!this.hasStatusError()) {
        if (!this.userInfo.stripe_customer_id) {
          await this.initCreateStripeCustomer();
        } else {
          await this.addNewSripeCard();
        }
      }

      const shouldChargeCard = this.eventLodging
        ? !this.bankTransferRequested
        : this.totalCompensationWithGuide > 0;

      if (!this.hasStatusError() && shouldChargeCard) {
        await this.initPaymentIntent();
        await this.initConfirmCardPayment();
      }

      if (!this.hasStatusError()) {
        if (this.accomodationCode) {
          await this.ReqAccomBook();
        }
      }
      setTimeout(async () => {
        if (!this.hasStatusError()) {
          await this.createReservation();
        } else {
          // Send payment failure info to Formspree
          this.sendPaymentFailureToFormspree();
          // Track pending reservation for admin follow-up
          this.trackPendingReservation('failure');
          this.resetStripeElements();
        }
        this.isProcessingPayment = false;
        this.updateUserBookingStatus();
      }, 1000);
      // Update loyalty user points
      if (this.loyalty_token.length > 0) {
        if (this.loyaltyUser) {
          this.updateLoyaltyPoints(true);
        }
        if (this.loyaltyCode.code_type === 1 && this.loyaltyCode.code_type_trigger <= this.numberOfNights) {
          console.log('IN STATUS BY CODE');
          this.updateUserStatusByCode(this.loyaltyCode.code_type_description);
        } else if (this.loyaltyCode.code_type === 0 && this.loyaltyCode.code_type_trigger <= this.numberOfNights) {
          console.log('IN TOKEN BY CODE');
          this.updateUserTokenByCode(this.loyaltyCode.code_type_description);
        }
      }
    },
    // Checks whether any payment pipeline step has explicitly failed.
    hasStatusError() {
      const error = Object.values(this.status).find((el) => el === false);
      return error === false ? true : false;
    },
    // Formats child count label in French with proper pluralization.
    formatChilds() {
      let enfant = " Enfant";
      const childsCount = this.childs || 0;
      if (childsCount > 1) {
        enfant += "s";
      }
      return childsCount + enfant;
    },
    // Formats adult count label in French with proper pluralization.
    formatAdults() {
      let adulte = " Adulte";
      const adultsCount = this.adults || 2;
      if (adultsCount > 1) {
        adulte += "s";
      }
      return adultsCount + adulte;
    },
    async fetchEvergreen() {
      try {
        const responseEvergreen = await fetcher.get(
          "/programme-evergreen-demarche-environnementale/"
        );
        this.evergreens = await responseEvergreen.data;
      } catch (e) {
        console.error(e);
      }
    },
    // Requests user location to estimate travel distance for carbon offset calculations.
    askForPosition() {
      navigator.geolocation.getCurrentPosition(
        (el) => {
          this.userLatitude = el.coords.latitude;
          this.userLongitude = el.coords.longitude;
        },
        (_e) => {
          try {
            const response = fetcher.get("/carbon_offsets/distance", {
              params: { id: this.lodging.id, city: this.userInfo.city },
            });
            this.distanceBetween = response.data;
          } catch (e) {
            console.error(e);
          }
        }
      );
    },
    // Converts loyalty points input to its euro compensation equivalent.
    fromPointsToPrice(e) {
      this.compensationPointToEarn = parseInt(e.target.value, 10);
      this.compensationToPay = ((this.compensationPointToEarn * 15) / 50).toFixed(2);
      this.compensationPointToEarn =
        parseInt(e.target.value, 10) > 1000 ? 1000 : parseInt(e.target.value, 10);
    },
    // Converts euro compensation input to loyalty points equivalent.
    fromPriceToPoints(e) {
      this.compensationToPay = parseInt(e.target.value, 10);
      this.compensationPointToEarn = ((this.compensationToPay * 50) / 15).toFixed();
      this.compensationPointToEarn =
        parseInt(e.target.value, 10) > 1000 ? 1000 : parseInt(e.target.value, 10);
    },
    // Applies selected transport mode and recalculates combined offset totals.
    chooseTransportEngine(compensation, id) {
      this.selectedTransportEngin = id;
      const chosen = this[compensation];

      this.totalCompensationCarbonOffset =
        chosen.compensation_carbon_offset +
        this.compensationByNightsAndTravelers.compensation_carbon_offset;

      this.totalCompensationAmount =
        chosen.compensation_amount +
        this.compensationByNightsAndTravelers.compensation_amount;
    },
    // Computes distance in kilometers between lodging and user coordinates.
    numberOfKm() {
      const radlat1 = (Math.PI * this.lodging.latitude) / 180;
      const radlat2 = (Math.PI * this.userLatitude) / 180;
      const theta = this.lodging.longitude - this.userLongitude;
      const radtheta = (Math.PI * theta) / 180;
      this.distanceBetween =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      this.distanceBetween = Math.acos(this.distanceBetween);
      this.distanceBetween = (this.distanceBetween * 180) / Math.PI;
      this.distanceBetween = this.distanceBetween * 60 * 1.1515;
      this.distanceBetween = this.distanceBetween * 1.609344;
    },
    // Formats a date into full French locale text (with weekday).
    formatDate(date) {
      let set;
      if (typeof date === 'string' && date.includes('/')) {
        const [day, month, year] = date.split('/').map(Number);
        set = new Date(year, month - 1, day);
      } else {
        set = new Date(date);
      }
      if (isNaN(set.getTime())) {
        console.error('Invalid Date');
        return 'Invalid Date';
      }
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return set.toLocaleString("fr-FR", options);
    },
    // Formats a date into French locale text without weekday.
    formatDateWithoutWeekday(date) {
      let set;
      if (typeof date === 'string' && date.includes('/')) {
        const [day, month, year] = date.split('/').map(Number);
        set = new Date(year, month - 1, day);
      } else {
        set = new Date(date);
      }
      if (isNaN(set.getTime())) {
        console.error('Invalid Date');
        return 'Invalid Date';
      }
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return set.toLocaleString("fr-FR", options);
    },
    // Keeps the reservation summary date line compact without affecting other date displays.
    formatReservationDateLine(date) {
      let set;
      if (typeof date === 'string' && date.includes('/')) {
        const [day, month, year] = date.split('/').map(Number);
        set = new Date(year, month - 1, day);
      } else {
        set = new Date(date);
      }
      if (isNaN(set.getTime())) {
        console.error('Invalid Date');
        return 'Invalid Date';
      }
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return set.toLocaleString("fr-FR", options);
    },
    // Computes the actual calendar date for a payment schedule item based on checkin or booking date.
    scheduleItemDate(item) {
      try {
        let baseDate;
        if (item.offset_type === 'before_checkout') {
          // Base = checkin date (this.from) — D-X before arrival
          baseDate = this.toDate(this.formatDateKoedia(this.from));
          if (isNaN(baseDate.getTime())) baseDate = new Date(this.from);
          baseDate = new Date(baseDate.getTime() - item.days_offset * 24 * 60 * 60 * 1000);
        } else {
          // Base = today + days_offset (after booking)
          baseDate = new Date();
          baseDate = new Date(baseDate.getTime() + item.days_offset * 24 * 60 * 60 * 1000);
        }
        if (isNaN(baseDate.getTime())) return '';
        return baseDate.toLocaleString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
      } catch (e) {
        return '';
      }
    },
    // Computes the euro amount for a payment schedule item based on total booking amount.
    scheduleItemAmount(item) {
      const pct = Number(item.percentage) || 0;
      return ((this.totalAmount * pct) / 100).toFixed(2);
    },
    formatDateToFrench(dateInput) {
      const date = new Date(dateInput);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    toDate(date) {
      return new Date(date);
    },
    formatDateSyntax(date) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
      const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
      return `${day}/${month}/${year}`;
    },
    // Handles step transitions and validates required data before proceeding.
    changeStep(step, triggerAuto = false) {
      switch (step) {
        case 1:
          // Check if logged-in user is missing phone number
          let bookingWindow = null;
          if (this.from) {
            const dateIn = new Date(`${this.from}`);
            const today = new Date();
            const timeDifference = dateIn - today;
            bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          }
          const lodgingTypeMapping = {
            Hotel: "hôtels",
            "Maison et Villa": "maisons et villas",
            Guestroom: "chambres d'hôtes",
            Lodge: "lodges et lieux insolites",
            Appartment: "appartements",
            Chalet: "chalets"
          };
          if (this.shouldSendReservationEventOnce('add_personal_info')) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'add_personal_info',
              ecommerce: {
                currency: 'EUR',
                value: parseFloat((this.accomodationCode && this.loyalty_token?.length === 0) ? this.totalTtc : (this.accomodationCode && this.loyalty_token?.length != 0) ? this.totalTtcLoyalty : this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia),
                number_of_nights: this.numberOfNights || 1,
                date_in: this.formatDateSyntax(this.toDate(this.from)),
                date_out: this.formatDateSyntax(this.toDate(this.to)),
                number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
                number_of_adult: this.adults || 0,
                number_of_child: this.childs || 0,
                booking_window: bookingWindow || 2,
                items: [{
                  item_name: this.lodging.name,
                  item_id: this.lodging.id,
                  price: parseFloat((this.accomodationCode && this.loyalty_token?.length === 0) ? this.totalTtc : (this.accomodationCode && this.loyalty_token?.length != 0) ? this.totalTtcLoyalty : this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia),
                  item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
                  item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie',
                  item_category: 'Nos hébergements',
                  item_variant: lodgingTypeMapping[this.lodging.type] || "hôtels",
                }]
              },
            });
            window.dataLayer.push({
              event: 'page_view',
              page: {
                page_type: 'personal_info',
                page_category: 'reservation',
              },
              user: {
                email: "",
              },
            });
          }
          if (this.user && !this.userInfo.phone) {
            this.missingPhoneForLoggedUser = true;
            return;
          } else {
            this.missingPhoneForLoggedUser = false;
          }

          // Validate phone number length (minimum 10 characters)
          if (this.userInfo.phone && this.userInfo.phone.length < 10) {
            this.incompleteInformation = true;
            return;
          }

          if (!this.validateUserInfo()) {
            this.incompleteInformation = true;
            return;
          } else {
            this.incompleteInformation = false;
          }

          // Update user phone if logged-in user has phone
          if (this.user && this.userInfo.phone) {
            this.updateUserPhone();
          }

          this.informationsCompleted = true;

          if (this.informationsCompleted) {
            this.trackPendingReservation();
          }

          if (this.hasSupplementsStep) {
            this.step = 2;
            if (!triggerAuto) {
              this.scrollToSection('step-supplements', 200);
            }
            break;
          }

          if (this.hideTemporarySections) {
            this.step1Completed = true;
            if (!triggerAuto) {
              this.scrollToSection('step-3', 200);
            }
            this.step = 3;
          } else {
            if (this.distanceBetween === 0) {
              this.numberOfKm();
            }
            this.fetchEmissionByNightsAndTravelers();
            this.scrollToSection('step-1', 200);
            this.step = 2;
          }
          break;
        case 2:
          this.step1Completed = true;
          this.step = 3;

          // Legacy case 2 logic (carbon offset step) kept commented out on request.
          // if (this.distanceBetween === 0) {
          //   this.numberOfKm();
          // }
          // this.fetchEmissionByNightsAndTravelers();
          // this.step = step;
          // window.dataLayer = window.dataLayer || [];
          // window.dataLayer.push({
          //   event: 'carbon_offset_step',
          //   page: {
          //     page_type: 'booking_checkout',
          //     page_category: 'carbon_offset_step',
          //   },
          //   user: {
          //     email: "",
          //   },
          // });
          // this.scrollToSection(this.hasTravelGuideImage ? 'step-2' : 'step-3', 500);

          if (this.hideTemporarySections) {
            this.scrollToSection('step-3', 200);
          } else {
            this.scrollToSection('step-1', 200);
          }
          break;
        case 3:
          this.step = step;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'travel_guide_step',
            page: {
              page_type: 'booking_checkout',
              page_category: 'travel_guide_step',
            },
            user: {
              email: "",
            },
          });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'carbon_offset_step',
            page: {
              page_type: 'booking_checkout',
              page_category: 'carbon_offset_step',
            },
            user: {
              email: "",
            },
          });
          this.scrollToSection('step-3');
          break;
      }
    },
    // Smooth-scrolls to a section while compensating fixed header height.
    scrollToSection(sectionId, headerOffset = 100) {
      const section = document.getElementById(sectionId);

      if (section) {
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    // Fetches carbon-offset estimations by nights, travelers, and distance.
    async fetchEmissionByNightsAndTravelers() {
      try {
        let adults = this.adults ?? 0;
        let childs = this.childs ?? 0;

        if (isNaN(adults)) adults = 0;
        if (isNaN(childs)) childs = 0;

        let number_of_travelers = adults + childs;

        const response = await fetcher.get("/carbon_offsets/all_info", {
          params: {
            number_of_nights: this.numberOfNights,
            number_of_travelers: number_of_travelers,
            number_of_km: this.distanceBetween,
            national: "true",
          },
        });
        this.compensationByNightsAndTravelers = response.data.hotel;
        this.compensationByPlane = response.data.plane;
        this.compensationByTrain = response.data.train;
        this.compensationByCar = response.data.car;
        this.totalCompensationCarbonOffset =
          this.compensationByNightsAndTravelers.compensation_carbon_offset;
        this.totalCompensationAmount = this.compensationByNightsAndTravelers.compensation_amount;
      } catch (e) {
        console.error(e);
      }
    },
    async fetchLodging() {
      try {
        const response = await fetcher.get("/lodgings/" + this.lodging.slug);
        this.lodgingMount = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    // Returns all lodging gifts marked as active/inactive for a given loyalty status.
    fetchGifts(trotterId) {
      const normalizeName = name =>
        name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      const greenTrotters = this.lodging.green_trotters || [];

      const selectedTrotter = greenTrotters.find(gt => gt.name === trotterId);
      if (!selectedTrotter) return [];

      // Collect all unique gifts from all green trotters
      const allGifts = Array.from(
        new Map(
          greenTrotters
            .flatMap(gt => gt.gifts || [])
            .map(gift => [normalizeName(gift.name), gift])
        ).values()
      );

      const currentGifts = selectedTrotter.gifts || [];

      return allGifts.map((gift) => ({
        name: gift.name,
        active: currentGifts.some((g) => g.name === gift.name)
      }));
    },
    getDisplayGifts(statusId) {
      const gifts = this.fetchGifts(statusId);
      return gifts?.filter(g => g.active).map(g => g.name)?.slice(-1) || "";
    },
    calculateServicesFromCode(currentServices, codeServiceCount) {
      // Calculate the number of services to add based on loyalty code
      // If user has 1 service and code allows 3, make it 3
      // Cap at maximum available services (4)
      const maxServices = 4;
      const newServiceCount = Math.min(codeServiceCount, maxServices);
      const currentActiveCount = currentServices.filter(s => s.active).length;
      
      // If code allows more services than currently active, add more
      if (newServiceCount > currentActiveCount) {
        const servicesToAdd = newServiceCount - currentActiveCount;
        const inactiveServices = currentServices.filter(s => !s.active);
        
        // Activate the required number of inactive services
        for (let i = 0; i < servicesToAdd && i < inactiveServices.length; i++) {
          inactiveServices[i].active = true;
        }
      }
      
      return currentServices;
    },
    // Validates minimum required customer fields before checkout can continue.
    validateUserInfo() {
      return this.userInfo.first_name && this.userInfo.last_name && this.userInfo.email && this.userInfo.phone;
    },
    updateUserBookingStatus() {
      if (!this.user) {
        fetcher
          .patch("/update_booking_status", {
            user: {
              email: this.userInfo.email
            },
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    // Applies lodging-level discount while preventing double-discount on tariff-adjusted totals.
    calculateDiscount() {
      if (!(this.discountPercentage > 0)) return;

      const selectedTariffs = Array.isArray(this.selectedTariffs) ? this.selectedTariffs : [];
      const hasEmbeddedTariffDiscount = selectedTariffs.some((tariffItem) => {
        const embedded = Number(tariffItem?.priceData?.discountPercentage);
        return Number.isFinite(embedded) && embedded > 0;
      });

      // Multi-room totals from selectedTariffs are already discount-adjusted in LodgingshowRooms.
      // Avoid subtracting the lodging discount a second time.
      if (hasEmbeddedTariffDiscount) {
        this.lodgingDiscountAmount = selectedTariffs.reduce((sum, tariffItem) => {
          const qty = Number(tariffItem?.qty) > 0 ? Number(tariffItem.qty) : 1;
          const discountedTotal = Number(tariffItem?.priceData?.totalPrice) || 0;
          const embeddedPct = Number(tariffItem?.priceData?.discountPercentage);
          const pct = Number.isFinite(embeddedPct) && embeddedPct > 0
            ? embeddedPct
            : Number(this.discountPercentage);

          if (!(pct > 0) || discountedTotal <= 0 || pct >= 100) return sum;

          const originalTotal = discountedTotal / (1 - (pct / 100));
          const discountAmount = originalTotal - discountedTotal;
          return sum + (discountAmount * qty);
        }, 0);

        this.lodgingDiscountPercentageText = `-${this.discountPercentage}%`;
        return;
      }

      if (this.accomodationCode) {
        this.lodgingDiscountAmount = (this.totalWithCode * this.discountPercentage) / 100;
        this.totalTtc = this.totalTtc - this.lodgingDiscountAmount;
      } else {
        this.lodgingDiscountAmount = (this.totalWithoutCode * this.discountPercentage) / 100;
        this.totalTtcNotKoedia = this.totalTtcNotKoedia - this.lodgingDiscountAmount;
        console.log('this.totalTtcNotKoedia', this.totalTtcNotKoedia)
      }
      this.lodgingDiscountPercentageText = `-${this.discountPercentage}%`;
    },
    // Generates a lightweight client session id for reservation/pending tracking.
    generateSessionId() {
      return 'rs_' + Math.random().toString(36).substr(2, 12);
    },
    normalizeCancellationMessage(message) {
      if (Array.isArray(message)) return message.join(' | ');
      if (message && typeof message === 'object') return JSON.stringify(message);
      return message || '';
    },
    findRoomById(roomId) {
      if (!this.lodging?.rooms || !roomId) return null;
      return this.lodging.rooms.find((room) => String(room.id) === String(roomId)) || null;
    },
    toMoneyNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    },
    normalizeKoediaRoomId(roomId) {
      if (roomId == null || roomId === '') return null;
      return String(roomId);
    },
    extractKoediaRoomIdsFromTariff(tariffItem) {
      if (!tariffItem) return [];

      const roomIds = Array.isArray(tariffItem.koediaRoomIds)
        ? tariffItem.koediaRoomIds.map((id) => this.normalizeKoediaRoomId(id)).filter(Boolean)
        : [];

      if (roomIds.length > 0) return roomIds;

      const singleId = this.normalizeKoediaRoomId(tariffItem.koediaRoomId);
      return singleId ? [singleId] : [];
    },
    // Resolves the primary Koedia room id from selected tariffs or fallback props.
    resolvePrimaryKoediaRoomId() {
      if (Array.isArray(this.selectedTariffs) && this.selectedTariffs.length > 0) {
        for (const tariff of this.selectedTariffs) {
          const roomIds = this.extractKoediaRoomIdsFromTariff(tariff);
          if (roomIds.length > 0) return roomIds[0];
        }
      }

      const fromKoediaRoomId = this.normalizeKoediaRoomId(this.koediaRoomId);
      if (fromKoediaRoomId) return fromKoediaRoomId;

      return this.normalizeKoediaRoomId(this.selectedOption?.room_id);
    },
    resolveTariffKoediaRoomId(index, breakdown = null) {
      const tariff = Array.isArray(this.selectedTariffs) ? this.selectedTariffs[index] : null;
      const roomIds = this.extractKoediaRoomIdsFromTariff(tariff);
      if (roomIds.length > 0) return roomIds[0];

      const fromBreakdown = this.normalizeKoediaRoomId(breakdown?.koediaRoomId);
      if (fromBreakdown) return fromBreakdown;

      return this.resolvePrimaryKoediaRoomId();
    },
    isRateDetailsRefundable(rateDetails) {
      const flag = rateDetails?.rate_information?.refundable;
      if (typeof flag === 'boolean') return flag;
      if (flag == null) return false;
      const normalized = String(flag).trim().toLowerCase();
      return ['true', '1', 'oui', 'yes', 'y'].includes(normalized);
    },
    // ─── Shared Koedia cancellation-policy helpers ────────────────────────────
    //
    // All helpers below are intentionally kept as plain functions (not methods)
    // so they can be called both from computed properties and from methods
    // without relying on `this` inside the pure parsing logic.

    // Safely reads a numeric value, returning `fallback` for NaN/non-finite.
    _parseNumber(value, fallback = 0) {
      const n = Number(value);
      return Number.isFinite(n) ? n : fallback;
    },

    // Reads an attribute that may appear with or without a leading '@' prefix
    // in the JSON-converted Koedia XML response.
    _getPolicyAttr(obj, key) {
      if (!obj || typeof obj !== 'object') return null;
      return obj[key] ?? obj[`@${key}`] ?? null;
    },

    // Determines whether a policy entry applies before check-in or after booking.
    _getPolicyRef(policy) {
      if (policy?.from_day && typeof policy.from_day === 'object') {
        return String(policy.from_day['@ref'] || 'before_checkin').toLowerCase();
      }
      return String(policy?.from_day_ref || policy?.ref || 'before_checkin').toLowerCase();
    },

    // Resolves the fee_unit_type for a policy, checking policy-level, amount-level,
    // and percentage-level locations (all introduced or extended by Koedia Oct-2025).
    _getPolicyUnit(policy) {
      return (
        this._getPolicyAttr(policy, 'unit') ||
        this._getPolicyAttr(policy?.amount, 'unit') ||
        this._getPolicyAttr(policy?.percentage, 'unit') ||
        ''
      ).toString().toLowerCase().trim();
    },

    // Reads the optional nights_percentage attribute (days_as_x_pct unit, Oct-2025).
    // Returns a finite number or null when the attribute is absent.
    _getNightsPercentage(policy) {
      const val =
        this._getPolicyAttr(policy, 'nights_percentage') ||
        this._getPolicyAttr(policy?.percentage, 'nights_percentage') ||
        this._getPolicyAttr(policy?.amount, 'nights_percentage');
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    },

    // Reads the optional apply_to_taxes attribute (Oct-2025).
    // When false, taxes are excluded from the cancellation fee server-side.
    // We read it here for tolerance; actual fee arithmetic is done by Koedia.
    // Returns true (default per spec) when the attribute is absent.
    _getApplyToTaxes(policy) {
      const val = this._getPolicyAttr(policy, 'apply_to_taxes');
      if (val === null || val === undefined) return true; // spec default: taxes included
      if (typeof val === 'boolean') return val;
      return String(val).trim().toLowerCase() !== 'false';
    },

    // Picks the most permissive before-check-in policy from a list,
    // falling back to all policies when none are before-check-in.
    _selectBestPolicy(policies) {
      const beforeCheckin = policies.filter((p) => this._getPolicyRef(p) !== 'after_booking');
      return (beforeCheckin.length ? beforeCheckin : policies)
        .slice()
        .sort((a, b) => this._parseNumber(b?.to_day, -1) - this._parseNumber(a?.to_day, -1))[0] || null;
    },

    // Converts a raw to_time value from Koedia into a display string.
    _formatToTime(rawToTime) {
      if (rawToTime === '0' || rawToTime === 0) return 'minuit';
      return rawToTime ? `${rawToTime} heures` : '';
    },

    // Core shared parser: converts a single Koedia CancellationPolicyRule into a
    // French-language policy sentence.  Handles all fee_unit_type values including
    // the five new ones introduced in the Oct-2025 WSDL update:
    //   booking_night | booking_day_checkout_incl | room_day_checkout_incl |
    //   pax_day_checkout_incl | days_as_x_pct
    // Also reads nights_percentage and apply_to_taxes tolerantly.
    //
    // @param selectedPolicy  – the chosen CancellationPolicyRule object
    // @param options.toDay           – days before check-in for free cancellation
    // @param options.fee             – raw rack fee amount (used for refundable %)
    // @param options.total           – total booking price (used for refundable %)
    // @returns {string} French policy sentence, or '' when no text can be formed.
    _parseCancellationPolicyText(selectedPolicy, { toDay, fee, total } = {}) {
      if (!selectedPolicy) return '';

      const isFullyRefundable = toDay > 0;
      const toTime = this._formatToTime(selectedPolicy?.to_time);
      const unit = this._getPolicyUnit(selectedPolicy);
      const nightsPct = this._getNightsPercentage(selectedPolicy);

      // apply_to_taxes is read for future use; fee computation remains server-side.
      // eslint-disable-next-line no-unused-vars
      const applyToTaxes = this._getApplyToTaxes(selectedPolicy);

      let refundablePercent = total > 0 ? Math.round(((total - fee) / total) * 100) : 0;
      refundablePercent = Math.max(0, Math.min(100, refundablePercent));

      // days_as_x_pct: fee is a % of the first N nights (nightsPct % of nightsVal nights).
      if (unit === 'days_as_x_pct') {
        const nightsVal = this._parseNumber(
          selectedPolicy?.percentage?.['#text'] ??
          selectedPolicy?.percentage?.content ??
          selectedPolicy?.percentage ??
          selectedPolicy?.amount?.['#text'] ??
          selectedPolicy?.amount?.content ??
          selectedPolicy?.amount ??
          fee,
          0
        );
        const pctDisplay = nightsPct !== null ? nightsPct : 100;
        if (isFullyRefundable) {
          return toTime
            ? `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (${toTime}) (puis frais de ${pctDisplay}% sur les ${nightsVal} premières nuits)`
            : `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (puis frais de ${pctDisplay}% sur les ${nightsVal} premières nuits)`;
        }
        return toTime
          ? `Frais d'annulation de ${pctDisplay}% sur les ${nightsVal} premières nuits jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
          : `Frais d'annulation de ${pctDisplay}% sur les ${nightsVal} premières nuits jusqu'à ${toDay} jours avant l'arrivée`;
      }

      // Night/day-count units: checkout day counts as a charged day.
      // booking_night is the pre-existing unit; the *_checkout_incl variants are new (Oct-2025).
      // We display date-range text only — never compute a fee from the raw day count.
      if (['booking_night', 'booking_day_checkout_incl', 'room_day_checkout_incl', 'pax_day_checkout_incl'].includes(unit)) {
        if (isFullyRefundable) {
          return toTime
            ? `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
            : `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée`;
        }
        return toTime
          ? `Remboursable selon conditions de l'établissement jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
          : `Remboursable selon conditions de l'établissement jusqu'à ${toDay} jours avant l'arrivée`;
      }

      // Default: percentage or fixed-amount fee expressed as a refundable fraction.
      if (isFullyRefundable) {
        return toTime
          ? `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
          : `Annulation gratuite jusqu'à ${toDay} jours avant l'arrivée`;
      }
      return toTime
        ? `Remboursable à hauteur de ${refundablePercent}% jusqu'à ${toDay} jours avant l'arrivée (${toTime})`
        : `Remboursable à hauteur de ${refundablePercent}% jusqu'à ${toDay} jours avant l'arrivée`;
    },

    // ─── End shared helpers ───────────────────────────────────────────────────

    // Builds normalized cancellation text lines from Koedia rate-details policies.
    buildCancellationItemsFromRateDetails(rateDetails, tariffItem = null) {
      if (!this.isRateDetailsRefundable(rateDetails)) {
        return [];
      }

      const rawPolicy = rateDetails?.cancellation_fees_policy;
      if (!rawPolicy) return [];

      const policies = (Array.isArray(rawPolicy) ? rawPolicy : [rawPolicy]).filter(Boolean);
      if (!policies.length) return [];

      const selectedPolicy = this._selectBestPolicy(policies);
      if (!selectedPolicy) return [];

      const toDay = this._parseNumber(selectedPolicy?.to_day, 0);
      const tariffTotal = this.toMoneyNumber(tariffItem?.priceData?.totalPrice);
      const fallbackTotal = this.toMoneyNumber(this.totalTtc);
      const total = this._parseNumber(
        rateDetails?.rate_information?.total_price?.['@rack'],
        tariffTotal > 0 ? tariffTotal : fallbackTotal
      );
      const fee = this._parseNumber(selectedPolicy?.amount?.['@rack'], 0);

      const policyText = this._parseCancellationPolicyText(selectedPolicy, { toDay, fee, total });

      return policyText
        ? [
            policyText,
            "En cas d'annulation, après cette date, le paiement intégral de la réservation sera dû.",
          ]
        : [];
    },
    formatAmount(value) {
      return this.toMoneyNumber(value).toFixed(2);
    },
    normalizeCancellationItems(value) {
      if (Array.isArray(value)) {
        return value
          .map((item) => (item == null ? '' : String(item).trim()))
          .filter(Boolean);
      }

      if (value == null) return [];

      const normalized = String(value).replace(/\s+/g, ' ').trim();
      return normalized ? [normalized] : [];
    },
    buildDefaultCancellationItems() {
      if (this.gettingRateDetails) return [];

      if (!this.isRefundable && (!this.refund || this.refund === false)) {
        return [
          'Tarif non remboursable.',
          "En cas d'annulation ou de non présentation, le paiement intégral de la réservation sera dû.",
        ];
      }

      const items = [];
      if (this.cancelationPolicy) {
        items.push(this.cancelationPolicy);
      }
      items.push("En cas d'annulation, après cette date, le paiement intégral de la réservation sera dû.");
      return items;
    },
    // Resolves cancellation lines from tariff data, fee text, or default policy fallback.
    resolveCancellationItems({ cancellationConditions, selectedPriceOptionFee } = {}) {
      const fromTariff = this.normalizeCancellationItems(cancellationConditions);
      if (fromTariff.length > 0) return fromTariff;

      const fromFee = this.normalizeCancellationItems(selectedPriceOptionFee);
      if (fromFee.length > 0) return fromFee;

      return this.buildDefaultCancellationItems();
    },
    // Builds a normalized per-tariff pricing breakdown used in summary and persistence.
    computeTariffRoomBreakdown(tariffItem, index = 0) {
      const priceData = tariffItem?.priceData || {};
      const qty = Number(tariffItem?.qty) > 0 ? Number(tariffItem.qty) : 1;
      const tvaRate = this.toMoneyNumber(this.tax?.tva_rate) / 100;

      let unitTotalTtc = this.toMoneyNumber(priceData.totalPrice);
      let unitTotalHt = this.toMoneyNumber(priceData.htValueTotal);
      let unitTotalTva = this.toMoneyNumber(priceData.tvalTotal);
      let unitTotalTax = this.toMoneyNumber(priceData.taxTotal);

      if (!this.accomodationCode && unitTotalTax <= 0 && this.selectedRoomCount > 0) {
        const sharedTax = this.toMoneyNumber(this.totalTaxNotKoedia) / this.selectedRoomCount;
        unitTotalTax = sharedTax > 0 ? sharedTax : 0;
      }

      if ((unitTotalHt <= 0 || unitTotalTva <= 0) && unitTotalTtc > 0) {
        const taxableBase = Math.max(unitTotalTtc - unitTotalTax, 0);
        if (tvaRate > 0) {
          unitTotalHt = taxableBase / (1 + tvaRate);
          unitTotalTva = taxableBase - unitTotalHt;
        } else {
          unitTotalHt = taxableBase;
          unitTotalTva = 0;
        }
      }

      if (unitTotalTtc <= 0) {
        unitTotalTtc = unitTotalHt + unitTotalTax + unitTotalTva;
      }

      return {
        roomId: tariffItem?.roomId || null,
        koediaRoomId: this.resolveTariffKoediaRoomId(index),
        roomName: tariffItem?.roomName || `Chambre ${index + 1}`,
        tariff: tariffItem?.tariff || null,
        qty,
        boardType: priceData.boardType || '',
        cancellationConditions: this.tariffCancellationOverrides[index] || priceData.cancellationConditions || '',
        selectedPriceOptionFee: this.tariffSelectedPriceOptionFeeOverrides[index] || priceData.selectedPriceOptionFee || tariffItem?.tariff_cancel_feed || null,
        unitPricePerNight: this.toMoneyNumber(priceData.pricePerNight),
        unitTotalHt,
        unitTotalTax,
        unitTotalTva,
        unitTotalTtc,
        totalHt: unitTotalHt * qty,
        totalTax: unitTotalTax * qty,
        totalTva: unitTotalTva * qty,
        totalTtc: unitTotalTtc * qty,
      };
    },
    // Normalizes room lines payload for single-room and multi-room reservation persistence.
    buildRoomLines(cancelConditions) {
      if (!this.selectedTariffs || this.selectedTariffs.length === 0) {
        return [{
          room_code: this.singleRoomCode,
          room_name: this.singleRoomName,
          board_type: this.board_type || '',
          cancellation_message: this.normalizeCancellationMessage(this.cancellation_message),
          cancel_conditions: cancelConditions || '',
          quantity: 1,
          price_per_night: 0,
          selected_price_option_fee: this.selectedPriceOptionFee || null,
          koedia_room_id: this.resolvePrimaryKoediaRoomId(),
          total_ht: this.toMoneyNumber(this.accomodationCode ? this.totalHt : this.totalHtNotKoedia),
          total_tax: this.toMoneyNumber(this.accomodationCode ? this.tax?.tourist_tax : this.totalTaxNotKoedia),
          total_tva: this.toMoneyNumber(this.accomodationCode ? this.tva : this.totalTvaNotKoedia),
          total_ttc: this.totalAmount.toFixed(2),
          metadata: {
            room_capacity: this.singleRoomCapacity,
            room_total_ht: this.toMoneyNumber(this.accomodationCode ? this.totalHt : this.totalHtNotKoedia),
            room_total_tax: this.toMoneyNumber(this.accomodationCode ? this.tax?.tourist_tax : this.totalTaxNotKoedia),
            room_total_tva: this.toMoneyNumber(this.accomodationCode ? this.tva : this.totalTvaNotKoedia),
            room_total_ttc: this.toMoneyNumber(this.accomodationCode ? this.totalWithCode : this.totalWithoutCode)
          }
        }];
      }

      return this.selectedTariffRoomBreakdowns.map((breakdown, index) => {
        const room = this.findRoomById(breakdown.roomId);

        return {
          room_code: room?.code || null,
          room_name: breakdown.roomName || room?.name || `Chambre ${index + 1}`,
          board_type: breakdown.boardType || '',
          cancellation_message: this.normalizeCancellationMessage(this.cancellation_message),
          cancel_conditions: breakdown.cancellationConditions || cancelConditions || '',
          quantity: breakdown.qty,
          price_per_night: breakdown.unitPricePerNight || 0,
          selected_price_option_fee: breakdown.selectedPriceOptionFee || null,
          koedia_room_id: this.resolveTariffKoediaRoomId(index, breakdown),
          total_ht: this.toMoneyNumber(breakdown.totalHt),
          total_tax: this.toMoneyNumber(breakdown.totalTax),
          total_tva: this.toMoneyNumber(breakdown.totalTva),
          total_ttc: this.toMoneyNumber(breakdown.totalTtc),
          metadata: {
            source: 'selectedTariffs',
            room_capacity: room?.capacity || null,
            room_id: breakdown.roomId || null,
            tariff_index: index,
            tariff_key: breakdown.tariff || null,
            unit_total_ht: this.toMoneyNumber(breakdown.unitTotalHt),
            unit_total_tax: this.toMoneyNumber(breakdown.unitTotalTax),
            unit_total_tva: this.toMoneyNumber(breakdown.unitTotalTva),
            unit_total_ttc: this.toMoneyNumber(breakdown.unitTotalTtc),
            room_total_ht: this.toMoneyNumber(breakdown.totalHt),
            room_total_tax: this.toMoneyNumber(breakdown.totalTax),
            room_total_tva: this.toMoneyNumber(breakdown.totalTva),
            room_total_ttc: this.toMoneyNumber(breakdown.totalTtc)
          }
        };
      });
    },
    // Tracks a pending reservation snapshot when user leaves before completion.
    handleBeforeUnload() {
      if (!this.status.createReservation) {
        this.trackPendingReservation();
      }
    },
    // Persists an incomplete reservation snapshot for abandonment or payment-failure follow-up.
    async trackPendingReservation(status = 'pending') {
      if (!this.userInfo?.email || !this.userInfo?.first_name || !this.userInfo?.last_name || !this.userInfo?.phone) return;
      
      try {
        let exclusiveOffer = "";
        if (this.exclusive) {
          exclusiveOffer = this.exclusive.title
        }
        let cancel_conditions = "Frais d'annulation de 30% jusqu'à 21 jours avant l'arrivée. Au-delà de 21 jours ou en cas de non-présentation, les frais d'annulation s'élèvent à 100%."

        if (!this.gettingRateDetails) {
          if (!this.isRefundable) {
            cancel_conditions = "En cas d'annulation ou de non présentation, le paiement intégral de la réservation sera dû."
          } else if (this.cancelationPolicy) {
            cancel_conditions = `${this.cancelationPolicy} En cas d'annulation, après cette date, le paiement intégral de la réservation sera dû.`;
          }
        }

        if (this.selectedPriceOptionFee) {
          cancel_conditions = this.selectedPriceOptionFee
        }
         
        // Track payment error when status is 'failure'
        let payment_error = null;
        if (status === 'failure') {
          payment_error = this.displayError?.textContent || 'Payment declined';
        }
        
        const data = {
          session_id: this.sessionId,
          is_phone: this.isPhone,
          ospita_tracking_id: ensureOspitaTrackingId(),
          pending_reservation:
          {
            room_code: this.singleRoomCode,
            checkin: this.from,
            check_out: this.to,
            total: this.totalAmount.toFixed(2),
            partner_discount_percentage: this.discountPercentage,
            duration: this.numberOfNights,
            payment_id: this.paymentIntentId,
            client_secret: this.clientSecret,
            booking_ref: this.bookingRef,
            koedia_booking_ref: this.koediaBookingRef,
            code_name: this.totalDiscountAmount > 0 ? this.code_promo : '',
            tva: this.tax?.tourist_tax,
            accommodation_code: this.accomodationCode,
            offer: exclusiveOffer,
            room_name: this.singleRoomName,
            koedia_room_id: this.resolvePrimaryKoediaRoomId(),
            koedia_session_id: status === 'failure' ? this.koediaSessionId : null,
            loyalty_token: this.tokenToResa,
            adults: this.adults,
            childs: this.childs,
            children_ages: this.normalizedChildrenAges,
            cancel_conditions: cancel_conditions,
            discount: this.totalDiscountAmount,
            cancellation_message: this.cancellation_message,
            board_type: this.board_type,
            email: this.userInfo.email,
            first_name: this.userInfo?.first_name,
            last_name: this.userInfo?.last_name,
            phone: this.userInfo?.phone,
            country: this.userInfo?.country,
            gift_box_promo: this.gift_box_promo,
            gift_box_discount_amount: this.giftBoxDiscountAmount,
            special_requests: this.specialRequests + this.supplementsTextForEmail,
            bank_transfer_requested: this.eventLodging && this.bankTransferRequested,
            guide_de_voyage: this.guideChecked ? 15.0 : 0,
            carbon_offset: this.compensationToPay || 0,
            house_hold_fee: this.houseHoldFeeAmount || 0,
            total_tva: this.accomodationCode ? this.tva : this.totalTvaNotKoedia,
            total_tax: this.accomodationCode ? this.tax?.tourist_tax : parseFloat(this.totalTaxNotKoedia),
            status: status,
            payment_error: payment_error,
            ospita_tracking_id: ensureOspitaTrackingId(),
            room_lines: this.buildRoomLines(cancel_conditions)
          }
        };

        await fetcher.post(`/lodgings/${this.lodging.slug}/pending_reservations`,
          data
        );
      } catch (error) {
        console.error('Error tracking pending reservation:', error);
      }
     },
    // Detects mobile keyboard visibility by monitoring viewport height changes.
    handleViewportChange() {
      if (this.isPhone) {
        const currentHeight = window.innerHeight;
        const heightDifference = this.initialViewportHeight - currentHeight;
        
        // If viewport height decreased by more than 150px, assume keyboard is open
        this.isKeyboardOpen = heightDifference > 150;
      }
    },
    updateDesktopSummaryScrollCue() {
      if (this.isPhone || !this.$refs.desktopSummaryCard) {
        this.showDesktopSummaryScrollCue = false;
        return;
      }

      const card = this.$refs.desktopSummaryCard;
      const remainingScroll = card.scrollHeight - card.clientHeight - card.scrollTop;
      this.showDesktopSummaryScrollCue = card.scrollHeight > card.clientHeight && remainingScroll > 12;
    },
    // Persists phone number for logged-in users who complete it during checkout.
    async updateUserPhone() {
      try {
        if (this.user && this.userInfo.phone) {
          const res = await fetcher.patch(`/dashboard/${this.user.id}`, {
            user: {
              phone: this.userInfo.phone
            }
          });
          this.informationsCompleted = true;
          this.phoneNotRegistered = false;
          console.log('User phone updated successfully:', res.data);
        }
      } catch (e) {
        console.error('Error updating user phone:', e);
      }
    },
    // Sends structured failed-payment diagnostics to Formspree for support follow-up.
    async sendPaymentFailureToFormspree() {
      // Only send to Formspree if URL doesn't include localhost
      if (window.location.href.includes('localhost')) {
        console.log('Skipping Formspree submission in localhost environment');
        return;
      }

      try {
        const formspreeId = 'mdazozay';
        const payload = {
          email: this.userInfo.email,
          first_name: this.userInfo.first_name,
          last_name: this.userInfo.last_name,
          phone: this.userInfo.phone,
          country: this.userInfo.country,
          city: this.userInfo.city,
          lodging_name: this.lodging.name,
          lodging_id: this.lodging.id,
          room_name: this.paymentFailureRoomName,
          checkin: this.formatDate(this.from),
          checkout: this.formatDate(this.to),
          duration: this.numberOfNights,
          adults: this.adults,
          childs: this.childs,
          children_ages: this.normalizedChildrenAges,
          koedia_room_id: this.resolvePrimaryKoediaRoomId(),
          koedia_session_id: this.koediaSessionId || null,
          ospita_tracking_id: ensureOspitaTrackingId(),
          total: this.totalAmount.toFixed(2),
          payment_status: 'failed',
          payment_error: this.displayError?.textContent || 'Payment declined',
          session_id: this.sessionId,
          timestamp: new Date().toISOString(),
          special_requests: this.specialRequests || 'none',
          guide_de_voyage: this.guideChecked ? 15.0 : 0,
          carbon_offset: this.compensationToPay || 0,
          promo_code: this.code_promo || '',
          gift_box_promo: this.gift_box_promo || '',
          from_phone: this.isPhone
        };

        const response = await fetch(`https://formspree.io/f/${formspreeId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          console.error('Failed to send payment failure to Formspree:', response.statusText);
        } else {
          console.log('Payment failure information sent to Formspree successfully');
        }
      } catch (error) {
        console.error('Error sending payment failure to Formspree:', error);
      }
    },
    // Returns loyalty privilege summary text based on user status or applied code.
    privilegesText(withStatus) {
      const map = {
        'Green Trotter': 1,
        'Green Trotter Plus': 2,
        'Green Trotter Premium': 3,
        'Green Trotter Infinite': 4
      }

      let count = map[this.loyaltyUser?.loyalty_status] || 0

      // If loyalty code with services is applied, use the code service count instead
      if (this.loyaltyCodeServiceCount > 0 && !withStatus) {
        count = this.loyaltyCodeServiceCount;
      }

      if (count === 0) return 'Cumulez des points pour débloquer des privilèges'

      return `${count} privilège${count > 1 ? 's' : ''} exclusif${count > 1 ? 's' : ''}`
    },
  },
  computed: {
    normalizedChildrenAges() {
      return Array.isArray(this.childrenAges)
        ? this.childrenAges
            .map((age) => age?.toString()?.trim())
            .filter((age) => age && age !== '')
        : [];
    },
    eventLodging() {
      return this.lodging?.event_lodging || this.lodgingMount?.event_lodging || false;
    },
    // Payment schedule computed properties
    sortedScheduleItems() {
      if (!this.paymentSchedule || !Array.isArray(this.paymentSchedule.items)) return [];
      return [...this.paymentSchedule.items].sort((a, b) => {
        // after_booking items first (chronologically earliest), then before_checkout sorted desc
        if (a.offset_type === 'after_booking' && b.offset_type !== 'after_booking') return -1;
        if (a.offset_type !== 'after_booking' && b.offset_type === 'after_booking') return 1;
        if (a.offset_type === 'after_booking') return a.days_offset - b.days_offset;
        // before_checkout: larger days_offset = earlier date
        return b.days_offset - a.days_offset;
      });
    },
    scheduleOnlineAmount() {
      if (!this.paymentSchedule) return '0.00';
      const pct = Number(this.paymentSchedule.online_percentage) || 0;
      return ((this.totalAmount * pct) / 100).toFixed(2);
    },
    scheduleRemainderPercentage() {
      if (!this.paymentSchedule) return 0;
      const itemsTotal = (this.paymentSchedule.items || []).reduce((sum, item) => sum + (Number(item.percentage) || 0), 0);
      return Math.max(0, 100 - (Number(this.paymentSchedule.online_percentage) || 0) - itemsTotal);
    },
    scheduleRemainderAmount() {
      return ((this.totalAmount * this.scheduleRemainderPercentage) / 100).toFixed(2);
    },
    normalizedSelectedTariffs() {
      return normalizeTariffSelection(this.selectedTariffs);
    },
    selectedRoomCount() {
      if (this.normalizedSelectedTariffs.length === 0) return 1;
      return this.normalizedSelectedTariffs.reduce((sum, tariff) => sum + (Number(tariff?.qty) || 1), 0);
    },
    isMultiRoomBooking() {
      return this.selectedRoomCount > 1 || this.normalizedSelectedTariffs.length > 1;
    },
    singleRoom() {
      if (this.normalizedSelectedTariffs.length === 1) {
        return this.findRoomById(this.normalizedSelectedTariffs[0]?.roomId) || this.item || null;
      }
      return this.item || null;
    },
    singleRoomName() {
      if (this.normalizedSelectedTariffs.length === 1) {
        return this.normalizedSelectedTariffs[0]?.roomName || this.singleRoom?.name || this.item?.name || 'Chambre';
      }
      return this.item?.name || 'Chambre';
    },
    paymentFailureRoomName() {
      if (this.selectedTariffRoomBreakdowns.length > 0) {
        return this.selectedTariffRoomBreakdowns
          .map((breakdown, index) => {
            const roomName = breakdown.roomName || `Chambre ${index + 1}`;
            return breakdown.qty > 1 ? `${roomName} x${breakdown.qty}` : roomName;
          })
          .join(', ');
      }

      return this.singleRoomName;
    },
    singleRoomCapacity() {
      if (this.normalizedSelectedTariffs.length === 1) {
        const roomById = this.findRoomById(this.normalizedSelectedTariffs[0]?.roomId);
        return roomById?.capacity || this.singleRoom?.capacity || this.item?.capacity || null;
      }
      return this.item?.capacity || null;
    },
    singleRoomCode() {
      if (this.normalizedSelectedTariffs.length === 1) {
        const roomById = this.findRoomById(this.normalizedSelectedTariffs[0]?.roomId);
        return roomById?.code || this.item?.code || null;
      }
      return this.item?.code || null;
    },
    bookingImageSrc() {
      if (this.isMultiRoomBooking) {
        return this.lodging?.photo_banner || null;
      }
      return this.singleRoom?.photo_banner || this.item?.photo_banner || this.lodging?.photo_banner || null;
    },
    bookingImageAlt() {
      if (this.isMultiRoomBooking) {
        return this.lodging?.name || 'Hébergement';
      }
      return this.singleRoomName;
    },
    bookingHeaderTitle() {
      if (this.isMultiRoomBooking) {
        return this.lodging?.name || 'Hébergement';
      }
      return this.singleRoomName;
    },
    hasTravelGuideImage() {
      return this.lodging?.lodging_description?.travel_guide_image && this.lodging?.lodging_description?.travel_guide_image !== 'null';
    },
    paymentSectionEnabled() {
      if (this.hideTemporarySections) {
        return this.step1Completed;
      } else {
        return this.hasTravelGuideImage ? this.step2Completed : this.step1Completed;
      }
    },
    canSubmitPayment() {
      if (!this.informationsCompleted) return false;
      if (this.user && !this.userInfo.phone) return false;
      if (this.userInfo.phone && this.userInfo.phone.length < 10) return false;
      return !!this.validateUserInfo();
    },
    travelGuideImageUrl() {
      return this.hasTravelGuideImage ? this.lodging.lodging_description.travel_guide_image : '';
    },
    travelGuideLink() {
      const guideLink = this.lodging?.lodging_description?.travel_guide_link;
      return guideLink && guideLink !== 'null' ? guideLink : '#';
    },
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    tokenToResa() {
      if (this.loyalty_token.length > 0) {
        const token = this.loyalty_token[0];
        if (token === 'first')
          return 50;
        else if (token === 'second')
          return 100;
        else if (token === 'third')
          return 150;
        else if (token === 'fourth')
          return 200;
        else if (token === 'fifth')
          return 250;
        else if (token === 'sixth')
          return 300;
      }
    },
    totalTtcLoyaltyNotKoedia() {
      let sum = 0;
      let sumArr = [];

      console.log('IN NOT KOEDIA');
      console.log(this.loyalty_token);

      sumArr = this.loyalty_token.map(element => {
        if (element.includes('first')) {
          return 50;
        } else if (element.includes('second')) {
          return 100;
        } else if (element.includes('third')) {
          return 150;
        } else if (element.includes('fourth')) {
          return 200;
        } else if (element.includes('fifth')) {
          return 250;
        } else if (element.includes('sixth')) {
          return 300;
        }
      });

      for (let i = 0; i < sumArr.length; i++) {
        sum += sumArr[i];
      }
      return (this.totalTtcNotKoedia - sum).toFixed(2);
    },
    totalTtcLoyalty() {
      let sum = 0;
      let sumArr = [];


      console.log('IN KOEDIA');
      console.log(this.loyalty_token);

      sumArr = this.loyalty_token.map(element => {
        if (element.includes('first')) {
          return 50;
        } else if (element.includes('second')) {
          return 100;
        } else if (element.includes('third')) {
          return 150;
        } else if (element.includes('fourth')) {
          return 200;
        } else if (element.includes('fifth')) {
          return 250;
        } else if (element.includes('sixth')) {
          return 300;
        }
      });

      console.log('SOMME ARRAY');
      console.log(sumArr);

      for (let i = 0; i < sumArr.length; i++) {
        sum += sumArr[i];
      }
      console.log('SOMME');
      console.log(sum);
      return (this.totalTtc - sum).toFixed(2);;
    },
    userRemainingStatus() {
      let statusData = null;
      
      if (this.loyaltyUser.loyalty_points >= 500 && this.loyaltyUser.loyalty_points < 1000) {
        statusData = { id: 'green trotter', name: "Green Trotter", services: this.fetchGifts('green trotter') };
      }
      else if (this.loyaltyUser.loyalty_points >= 1000 && this.loyaltyUser.loyalty_points < 1500) {
        statusData = { id: 'green trotter plus', name: "Green Trotter PLUS", services: this.fetchGifts('green trotter plus') };
      }
      else if (this.loyaltyUser.loyalty_points >= 1500 && this.loyaltyUser.loyalty_points < 2000) {
        statusData = { id: 'green trotter premium', name: "Green Trotter PREMIUM", services: this.fetchGifts('green trotter premium') };
      }
      else if (this.loyaltyUser.loyalty_points >= 2000) {
        statusData = { id: 'green trotter infinite', name: "Green Trotter INFINITE", services: this.fetchGifts('green trotter infinite') };
      }
      
      // Apply loyalty code service count if available
      if (statusData && this.loyaltyCodeServiceCount > 0) {
        statusData.services = this.calculateServicesFromCode(statusData.services, this.loyaltyCodeServiceCount);
      }
      
      return statusData;
    },
    servicesToDisplay() {
      const services = this.userRemainingStatus?.services;

      if (Array.isArray(services) && services.length) {
        return services.filter(service => service?.active);
      }

      // Fallback for users with low points but valid loyalty code type 2
      if (this.loyaltyCodeServiceCount > 0) {
        const baseServices = this.fetchGifts('green trotter') || [];
        return baseServices?.slice(0, this.loyaltyCodeServiceCount) || [];
      }

      return [];
    },
    userRemainingPoints(){
      if(this.loyaltyUser.loyalty_points < 500){
        return 500 - this.loyaltyUser.loyalty_points;
      }
      else if(this.loyaltyUser.loyalty_points >= 500 && this.loyaltyUser.loyalty_points < 1000){
        return 1000 - this.loyaltyUser.loyalty_points;
      }
      else if(this.loyaltyUser.loyalty_points >= 1000 && this.loyaltyUser.loyalty_points < 1500){
        return 1500 - this.loyaltyUser.loyalty_points;
      }
      else if(this.loyaltyUser.loyalty_points < 2500) {
        return 2500 - this.loyaltyUser.loyalty_points;
      }
    },
    nextUserStatus(){
      if(this.loyaltyUser.loyalty_points < 500){
        return "Green Trotter";
      }
      else if(this.loyaltyUser.loyalty_points >= 500 && this.loyaltyUser.loyalty_points < 1000){
        return "Green Trotter Plus";
      }
      else if(this.loyaltyUser.loyalty_points >= 1000 && this.loyaltyUser.loyalty_points < 1500){
        return "Green Trotter Premium";
      }
      else if(this.loyaltyUser.loyalty_points < 2500) {
        return "Green Trotter Infinite";
      }
    },
    reservationPoints() {
      return parseFloat(this.numberOfNights) * 50;
    },
    allLodgingGiftNames() {
      const normalizeName = name =>
        name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      if (!this.lodging || !Array.isArray(this.lodging.green_trotters)) return [];

      const giftMap = new Map();

      this.lodging.green_trotters.forEach(gt => {
        (gt.gifts || []).forEach(gift => {
          const key = normalizeName(gift.name);
          if (!giftMap.has(key)) {
            giftMap.set(key, gift.name);
          }
        });
      });

      let allGifts = Array.from(giftMap.values());
      
      // If loyalty code with services is applied, limit gifts to code service count
      if (this.loyaltyCodeServiceCount > 0) {
        allGifts = allGifts.slice(0, this.loyaltyCodeServiceCount);
      }

      return allGifts;
    },
    /*numberLoyaltyNights(){
        let loyalty_points = 0;
        if(this.loyaltyUser){
          loyalty_points = this.loyaltyUser.loyalty_points;
        }
        return Math.floor((loyalty_points + this.pointsDiff) / 100);
    },*/
    pointsDiff() {
      console.log('this.to');
      console.log(this.to);
      console.log('this.from');
      console.log(this.from);
      return 50 * Math.ceil((this.toDate(this.to) - this.toDate(this.from)) / (1000 * 60 * 60 * 24));
    },
    cancelationPolicy() {
      if (!this.isRefundable) return null;

      const rawPolicy = this.rateDetails?.cancellation_fees_policy;
      if (!rawPolicy) return null;

      // Support both single object and array responses.
      const policies = (Array.isArray(rawPolicy) ? rawPolicy : [rawPolicy]).filter(Boolean);
      if (!policies.length) return null;

      const selectedPolicy = this._selectBestPolicy(policies);
      if (!selectedPolicy) return null;

      const toDay = this._parseNumber(selectedPolicy?.to_day, 0);
      const total = this._parseNumber(
        this.rateDetails?.rate_information?.total_price?.['@rack'],
        Number(this.totalTtc) || 0
      );
      const fee = this._parseNumber(selectedPolicy?.amount?.['@rack'], 0);

      return this._parseCancellationPolicyText(selectedPolicy, { toDay, fee, total }) || null;
    },
    isRefundable() {
      if (this.rateDetails) {
        if (this.rateDetails.rate_information) {
          console.log('his.rateDetails', this.rateDetails)
          const flag = this.rateDetails.rate_information.refundable;
            if (typeof flag === 'boolean') return flag;
            if (flag == null) return false;
            const s = String(flag).trim().toLowerCase();
            return ['true', '1', 'oui', 'yes', 'y'].includes(s);       
           }
      }
    },
    paymentButtonCaption() {
      if (this.isProcessingPayment) {
        return "Paiement en cours...";
      } else {
        return `Réserver mon séjour`;
      }
    },
    showRoomReselectionCta() {
      return this.invalidRoomIdErrorActive;
    },
    priceWithTax() {
      return (this.total + this.tax.tourist_tax + this.tva).toFixed(2);
    },
    totalAmount() {
      let amount = parseFloat(this.accomodationCode
        ? (this.loyalty_token.length === 0 ? this.totalTtc : this.totalTtcLoyalty)
        : (this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia));
      amount += this.compensationPointToEarn ? parseFloat(this.compensationPointToEarn) : 0;
      if (this.guideChecked) {
        amount += 15
      }
      // Add household fee for non-Koedia entire lodgings
      if (!this.accomodationCode && this.lodging.is_entire && this.houseHoldFeeAmount > 0) {
        amount += parseFloat(this.houseHoldFeeAmount);
      }
      return amount;
    },
    // ── Supplements ──────────────────────────────────────────────────────────────
    SUPPLEMENT_META() {
      return [
        { key: 'lit_appoint',    label: "Lit d'appoint",   iconSrc: require('../../images/ic_lit_appoint.svg'),    hasQuantity: false, qtyLabel: '' },
        { key: 'lit_bebe',       label: 'Lit bébé',         iconSrc: require('../../images/ic_lit_bebe.svg'),       hasQuantity: false, qtyLabel: '' },
        { key: 'spa',            label: 'Spa',              iconSrc: require('../../images/ic_spa.svg'),            hasQuantity: false, qtyLabel: '' },
        { key: 'parking',        label: 'Parking',          iconSrc: require('../../images/ic_parking.svg'),        hasQuantity: false, qtyLabel: '' },
        { key: 'animaux',        label: 'Animaux',          iconSrc: require('../../images/ic_animaux.svg'),        hasQuantity: true,  qtyLabel: 'animal(aux)' },
        { key: 'petit_dejeuner', label: 'Petit déjeuner',   iconSrc: require('../../images/ic_petit_dejeuner.svg'), hasQuantity: true,  qtyLabel: 'pers.' },
        { key: 'dejeuner',       label: 'Déjeuner',         iconSrc: require('../../images/ic_diner.svg'),          hasQuantity: true,  qtyLabel: 'pers.' },
        { key: 'diner',          label: 'Diner',            iconSrc: require('../../images/ic_diner.svg'),          hasQuantity: true,  qtyLabel: 'pers.' },
        { key: 'massages_soins', label: 'Massages & soins', iconSrc: require('../../images/ic_massages_soins.svg'), hasQuantity: false, qtyLabel: '' },
      ];
    },
    availableSupplements() {
      const raw = this.lodging?.lodging_profile?.supplements;
      if (!raw) return [];

      const normalizedRaw = { ...raw };
      if (normalizedRaw.dejeuner_diner) {
        if (!normalizedRaw.dejeuner) normalizedRaw.dejeuner = { ...normalizedRaw.dejeuner_diner };
        if (!normalizedRaw.diner) normalizedRaw.diner = { ...normalizedRaw.dejeuner_diner };
      }

      return this.SUPPLEMENT_META
        .filter(meta => {
          const entry = normalizedRaw[meta.key];
          return entry && entry.selection && entry.selection !== '';
        })
        .map(meta => ({
          ...meta,
          price: normalizedRaw[meta.key].price || '',
          info: normalizedRaw[meta.key].info || '',
          selection: normalizedRaw[meta.key].selection || '',
        }));
    },
    hasSupplementsStep() {
      return this.availableSupplements.length > 0;
    },
    selectedSupplements() {
      return Object.entries(this.selectedSupplementsMap)
        .filter(([, val]) => val && val.selected)
        .map(([key, val]) => {
          const meta = this.SUPPLEMENT_META.find(m => m.key === key) || {};
          const supplements = this.lodging?.lodging_profile?.supplements || {};
          const normalizedSupplements = { ...supplements };
          if (normalizedSupplements.dejeuner_diner) {
            if (!normalizedSupplements.dejeuner) normalizedSupplements.dejeuner = { ...normalizedSupplements.dejeuner_diner };
            if (!normalizedSupplements.diner) normalizedSupplements.diner = { ...normalizedSupplements.dejeuner_diner };
          }
          const raw = normalizedSupplements[key] || {};
          const priceNum = parseFloat(raw.price) || 0;
          const nights = parseInt(this.numberOfNights) || 1;
          const qty = val.qty || 1;
          // per-nuit supplements multiply by nights
          const isPerNuit = (raw.info || '').toLowerCase().includes('nuit') || (raw.info || '').toLowerCase().includes('night');
          const lineTotal = raw.selection === 'gratuit' ? 0 : (isPerNuit ? priceNum * nights * qty : priceNum * qty);
          return {
            key,
            label: meta.label || key,
            iconSrc: meta.iconSrc || '',
            qty,
            info: raw.info || '',
            reservationDate: val.reservationDate || '',
            preferredTimeSlot: val.preferredTimeSlot || '',
            lineTotal: Math.round(lineTotal * 100) / 100,
          };
        });
    },
    supplementsTotal() {
      return this.selectedSupplements.reduce((sum, s) => sum + s.lineTotal, 0);
    },
    supplementsTotalDisplay() {
      return this.supplementsTotal.toFixed(2);
    },
    supplementsTextForEmail() {
      if (this.selectedSupplements.length === 0) return '';
      const lines = this.selectedSupplements.map(s => {
        const hasStartingFromLabel = (s.info || '').trim() === 'À partir de';
        const price = s.lineTotal > 0
          ? ` (${hasStartingFromLabel ? 'À partir de ' : ''}${s.lineTotal.toFixed(2)} €)`
          : ' (Gratuit)';
        return `${s.label} ×${s.qty}${price}`;
      });
      return `\n\nServices supplémentaires sélectionnés :\n${lines.join('\n')}\nTotal services : ${this.supplementsTotalDisplay} €`;
    },
    selectedSupplementsSchedulePayload() {
      return this.selectedSupplements
        .filter(s => ['spa', 'dejeuner', 'diner', 'massages_soins'].includes(s.key))
        .map(s => ({
          key: s.key,
          label: s.label,
          qty: s.qty,
          reservation_date: s.reservationDate || '',
          preferred_time_slot: s.preferredTimeSlot || '',
        }));
    },
    selectedTariffRoomBreakdowns() {
      if (!Array.isArray(this.selectedTariffs) || this.selectedTariffs.length === 0) return [];
      return this.selectedTariffs.map((tariffItem, index) => this.computeTariffRoomBreakdown(tariffItem, index));
    },
    multiRoomCancellationPolicies() {
      if (!this.isMultiRoomBooking || this.selectedTariffRoomBreakdowns.length === 0) return [];

      return this.selectedTariffRoomBreakdowns
        .map((tariffItem, index) => ({
          qty: tariffItem.qty,
          roomName: tariffItem.roomName || `Chambre ${index + 1}`,
          boardType: tariffItem.boardType || '',
          items: this.resolveCancellationItems({
            cancellationConditions: tariffItem.cancellationConditions,
            selectedPriceOptionFee: tariffItem.selectedPriceOptionFee,
          }),
        }))
        .filter((policy) => policy.items.length > 0);
    },
    selectedTariffTotals() {
      if (!this.selectedTariffRoomBreakdowns.length) {
        return { totalHt: 0, totalTax: 0, totalTva: 0, totalTtc: 0 };
      }

      return this.selectedTariffRoomBreakdowns.reduce((totals, breakdown) => {
        totals.totalHt += this.toMoneyNumber(breakdown.totalHt);
        totals.totalTax += this.toMoneyNumber(breakdown.totalTax);
        totals.totalTva += this.toMoneyNumber(breakdown.totalTva);
        totals.totalTtc += this.toMoneyNumber(breakdown.totalTtc);
        return totals;
      }, { totalHt: 0, totalTax: 0, totalTva: 0, totalTtc: 0 });
    },
    summaryTotalHt() {
      if (this.selectedTariffRoomBreakdowns.length > 0) return this.selectedTariffTotals.totalHt;
      return this.accomodationCode ? this.toMoneyNumber(this.totalHt) : this.toMoneyNumber(this.totalHtNotKoedia);
    },
    summaryTotalTax() {
      if (this.selectedTariffRoomBreakdowns.length > 0) return this.selectedTariffTotals.totalTax;
      return this.accomodationCode ? this.toMoneyNumber(this.tax?.tourist_tax) : this.toMoneyNumber(this.totalTaxNotKoedia);
    },
    summaryTotalTva() {
      if (this.selectedTariffRoomBreakdowns.length > 0) return this.selectedTariffTotals.totalTva;
      return this.accomodationCode ? this.toMoneyNumber(this.tva) : this.toMoneyNumber(this.totalTvaNotKoedia);
    },
    totalWithCode() {
      return this.summaryTotalHt + this.summaryTotalTva;
    },
    totalWithoutCode() {
      return this.summaryTotalHt + this.summaryTotalTax + this.summaryTotalTva;
    },
    discountedReferenceAmount() {
      let amount = this.accomodationCode ? this.totalWithCode : this.totalWithoutCode;

      if (!this.accomodationCode && this.lodging.is_entire && this.houseHoldFeeAmount > 0) {
        amount += parseFloat(this.houseHoldFeeAmount);
      }

      return amount;
    },
    totalCompensationWithGuide() {
      return this.compensationToPay + this.guideCompensationToPay;
    },
    totalCompensationCalculated() {
      return this.compensationToPay + this.guideCompensationToPay;
    },
    totalDiscountAmount() {
      return this.promoDiscountAmount + this.lodgingDiscountAmount + this.giftBoxDiscountAmount + this.discountCodeAmount;
    },
    totalDiscountPercentageText() {
      const hasPromo = this.promoDiscountPercentageText !== '';
      const hasLodging = this.lodgingDiscountPercentageText !== '';
      const hasGiftBox = this.giftBoxDiscountPercentageText !== '';

      const isPromoFixed = hasPromo && this.promoDiscountPercentageText.includes('€');
      const isGiftBoxFixed = hasGiftBox && this.giftBoxDiscountPercentageText.includes('€');

      const numActiveDiscounts = [hasPromo, hasLodging, hasGiftBox].filter(Boolean).length;

      // Only one discount
      if (numActiveDiscounts === 1) {
        if (hasPromo) return this.promoDiscountPercentageText;
        if (hasLodging) return this.lodgingDiscountPercentageText;
        if (hasGiftBox) return this.giftBoxDiscountPercentageText;
      }

      // Mixed fixed-amount (€) discounts → compute total discount percentage
      if (numActiveDiscounts > 1 && (isPromoFixed || isGiftBoxFixed)) {
        const totalBeforeDiscount = this.totalAmount + this.totalDiscountAmount;

        if (totalBeforeDiscount === 0) return '';

        const discountPercentage = (this.totalDiscountAmount / totalBeforeDiscount) * 100;
        return `-${parseInt(discountPercentage)}%`;
      }

      // All discounts are percentage-based → sum them
      if (numActiveDiscounts > 1) {
        const promoPercentage = this.extractPercentage(this.promoDiscountPercentageText);
        const lodgingPercentage = this.extractPercentage(this.lodgingDiscountPercentageText);
        const giftBoxPercentage = this.extractPercentage(this.giftBoxDiscountPercentageText);

        const totalPercentage = promoPercentage + lodgingPercentage + giftBoxPercentage;
        return `${parseInt(totalPercentage)}%`;
      }

      return '';
    },
    statusArrowStyle() {
      const points = this.loyaltyUser?.loyalty_points || 0;
      // Checkpoints aligned with grid sections (middle of each section)
      const checkpoints = [500, 1000, 1500, 2500];
      const gridSectionCenters = [12.5, 37.5, 62.5, 87.5]; // % positions of section middles
      
      // Cap points at maximum checkpoint
      const cappedPoints = Math.min(points, checkpoints[checkpoints.length - 1]);
      
      let position = 0;
      
      if (cappedPoints <= checkpoints[0]) {
        // Before or at first checkpoint (0 to 500)
        // Position from 0% to 12.5% (start to middle of first section)
        position = (cappedPoints / checkpoints[0]) * gridSectionCenters[0];
      } else if (cappedPoints <= checkpoints[1]) {
        // Between 1st and 2nd checkpoint (500 to 1000)
        // Position from 12.5% to 37.5%
        const range = checkpoints[1] - checkpoints[0];
        const progress = (cappedPoints - checkpoints[0]) / range;
        position = gridSectionCenters[0] + (progress * (gridSectionCenters[1] - gridSectionCenters[0]));
      } else if (cappedPoints <= checkpoints[2]) {
        // Between 2nd and 3rd checkpoint (1000 to 1500)
        // Position from 37.5% to 62.5%
        const range = checkpoints[2] - checkpoints[1];
        const progress = (cappedPoints - checkpoints[1]) / range;
        position = gridSectionCenters[1] + (progress * (gridSectionCenters[2] - gridSectionCenters[1]));
      } else if (cappedPoints <= checkpoints[3]) {
        // Between 3rd and 4th checkpoint (1500 to 2500)
        // Position from 62.5% to 87.5%
        const range = checkpoints[3] - checkpoints[2];
        const progress = (cappedPoints - checkpoints[2]) / range;
        position = gridSectionCenters[2] + (progress * (gridSectionCenters[3] - gridSectionCenters[2]));
      } else {
        // Beyond final checkpoint
        position = gridSectionCenters[3];
      }
      
      // Arrow is 28px wide, so offset it by half width to center it
      const arrowOffset = 22; // half of 28px arrow width
      if (position <= 7) {
        return { left: `calc(${position}% - 22px)` };
      }
      return {
        left: `calc(${position}% - ${arrowOffset}px)`
      };
    },
    tripadvisorAllReviews() {
      const all = Array.isArray(this.lodging?.ratings) ? this.lodging.ratings : [];
      const clean = all.filter(r => (r && (r.title || r.review)));
      clean.sort((a, b) => {
        const da = new Date(a.rated_at || a.created_at || 0).getTime();
        const db = new Date(b.rated_at || b.created_at || 0).getTime();
        return db - da;
      });
      return clean;
    },
    tripadvisorGlobalRating() {
      return ((this.lodging?.lodging_description?.rating_value) && this.lodging?.lodging_description?.rating_value > 0) ? this.lodging?.lodging_description?.rating_value : "5.0";
    },
  },
  async mounted() {
    const tagsAccordions = document.getElementById('tagsAccordions');
    if (tagsAccordions) {
      tagsAccordions.style.display = 'none';
    }
    // this.fetchLodging();
    this.loginUser = this.user;
    this.phoneNotRegistered = this.user ? !this.user.phone : false;
    this.calculateDiscount();
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('resize', this.updateDesktopSummaryScrollCue);
    
    // Store initial viewport height for keyboard detection
    if (this.isPhone) {
      this.initialViewportHeight = window.innerHeight;
      window.addEventListener('resize', this.handleViewportChange);
    }
    if (isNaN(this.numberOfNights)) {
      this.numberOfNights = Math.ceil((this.toDate(this.formatDateKoedia(this.to)) - this.toDate(this.formatDateKoedia(this.from))) / (1000 * 60 * 60 * 24))
    }
    if (this.isPhone) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const visible = entry.isIntersecting;
          this.showFloatingBtn = !visible;
          this.showFloatingMenu = visible;
        },
        {
          root: null,
          threshold: 0,
        }
      );

      if (this.$refs.informationSection) {
        this.observer.observe(this.$refs.informationSection);
      }
    }

    if (window.location.search === "?signin" && !this.user) {
      this.showModal = true;
    }

    if (window.location.search === "?admin_login" && !this.user) {
      this.showAdminModal = true;
    }
    try {
      this.getRateDetails();
      this.fetchEvergreen();
      this.fetchUser();
      this.fetchLoyaltyUser();
      this.fetchInventories();
      this.mountStripeElements();
    } catch (e) {
      console.error(e);
    }
    this.$nextTick(() => {
      if (this.$refs.desktopSummaryCard) {
        this.$refs.desktopSummaryCard.addEventListener('scroll', this.updateDesktopSummaryScrollCue);
      }
      this.updateDesktopSummaryScrollCue();
      window.requestAnimationFrame(() => this.updateDesktopSummaryScrollCue());
      setTimeout(() => this.updateDesktopSummaryScrollCue(), 800);
    });
    let bookingWindow = null;

    if (this.from) {
      const dateIn = new Date(`${this.from}`);
      const today = new Date();
      const timeDifference = dateIn - today;
      bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    }
    const lodgingTypeMapping = {
      Hotel: "hôtels",
      "Maison et Villa": "maisons et villas",
      Guestroom: "chambres d'hôtes",
      Lodge: "lodges et lieux insolites",
      Appartment: "appartements",
      Chalet: "chalets"
    };
    if (this.shouldSendReservationEventOnce('begin_checkout')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: 'EUR',
          value: parseFloat((this.accomodationCode && this.loyalty_token?.length === 0) ? this.totalTtc : (this.accomodationCode && this.loyalty_token?.length != 0) ? this.totalTtcLoyalty  : this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia),
          number_of_nights: Math.ceil((this.toDate(this.to) - this.toDate(this.from)) / (1000 * 60 * 60 * 24)) || 1,
          date_in: this.formatDateSyntax(this.toDate(this.from)),
          date_out: this.formatDateSyntax(this.toDate(this.to)),
          number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
          number_of_adult: this.adults || 0,
          number_of_child: this.childs || 0,
          booking_window: bookingWindow || 2,
          items: [{
            item_name: this.lodging.name,
            item_id: this.lodging.id,
            price:  parseFloat((this.accomodationCode && this.loyalty_token?.length === 0) ?  this.totalTtc : (this.accomodationCode && this.loyalty_token?.length != 0) ? this.totalTtcLoyalty  : this.loyalty_token.length === 0 ? this.totalTtcNotKoedia : this.totalTtcLoyaltyNotKoedia),
            item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne' ,
            item_category: 'Nos hébergements',
            item_variant: lodgingTypeMapping[this.lodging.type] || "hôtels",
            item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie'
          }]
        }
      });
      const hashedEmail = await this.hashEmail(this.userInfo.email  || '');
      window.dataLayer.push({
        event: 'page_view',
        page: {
          page_type: 'start_checkout',
          page_category: 'reservation',
        },
        user: {
          email: hashedEmail || '',
        },
      });
    }
    this.numberOfKm();
    this.fetchEmissionByNightsAndTravelers();
    this.askForPosition();
  },
};
</script>
<style lang="scss" scoped src="./ReservationNewUserInfo.scss"></style>
